// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================================
   SIMULATEUR SOLAIRE AC FLUIDE - CSS COMPLET FINAL
   Correction complète du problème de chevauchement des suggestions
   =============================================== */

/* ===============================================
   VARIABLES CSS GLOBALES
   =============================================== */
:root {
  --color-primary: #1e40af;
  --color-success: #059669;
  --color-danger: #dc2626;
  --color-warning: #f59e0b;
  --color-text: #1f2937;
  --color-text-light: #64748b;
  --color-background: #ffffff;
  --color-surface: #f8fafc;
  --border-radius: 8px;
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);
  --z-suggestions: 9999;
  --z-modal: 10000;
  --z-tooltip: 1000;
  --z-sticky: 100;
}

/* ===============================================
   RESET ET BASE STYLES
   =============================================== */
* {
  box-sizing: border-box;
}

.simulator-solar-app {
  min-height: 100vh;
  background: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Inter', sans-serif;
  color: #1f2937;
  overflow-x: hidden;
  line-height: 1.5;
  font-size: 16px;
}

/* ===============================================
   ANIMATIONS GLOBALES
   =============================================== */
@keyframes simulator-fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes simulator-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
}

@keyframes simulator-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes simulator-slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes simulator-glow {
  0%, 100% {
    box-shadow: 0 0 5px rgba(30, 64, 175, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(30, 64, 175, 0.6);
  }
}

.simulator-spinning {
  animation: simulator-spin 1s linear infinite;
}

/* ===============================================
   HEADER
   =============================================== */
.simulator-app-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e2e8f0;
  padding: 0.75rem 0;
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  box-shadow: var(--shadow-sm);
}

.simulator-header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
}

.simulator-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.2s ease;
  border-radius: var(--border-radius);
  padding: 0.5rem;
}

.simulator-logo:hover {
  background: rgba(30, 64, 175, 0.05);
  transform: translateY(-1px);
}

.simulator-logo-image {
  width: 6rem;
  height: auto;
  object-fit: contain;
}

.simulator-logo-info {
  display: flex;
  flex-direction: column;
}

.simulator-logo-text {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--color-primary);
  line-height: 1;
}

.simulator-logo-tagline {
  font-size: 0.75rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-header-contact {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.simulator-contact-info {
  display: flex;
  gap: 1.5rem;
}

.simulator-contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--color-text);
}

.simulator-header-contact-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-primary);
  flex-shrink: 0;
}

.simulator-expert-btn {
  background: linear-gradient(135deg, var(--color-primary), #1d4ed8);
  color: white;
  border: none;
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 1px 3px rgba(30, 64, 175, 0.3);
  font-size: 0.8rem;
}

.simulator-expert-btn:hover {
  background: linear-gradient(135deg, #1d4ed8, #1e3a8a);
  transform: translateY(-1px);
}

.simulator-btn-icon {
  width: 1rem;
  height: 1rem;
}

.simulator-desktop-only {
  display: flex;
}

/* ===============================================
   PROGRESS BAR
   =============================================== */
.simulator-progress-bar {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-bottom: 1px solid #cbd5e1;
  padding: 1rem 0;
}

.simulator-progress-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.simulator-progress-navigation {
  flex: 1 1;
}

.simulator-progress-steps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 0;
}

.simulator-progress-step-container {
  display: flex;
  align-items: center;
}

.simulator-progress-step {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  background: #e2e8f0;
  color: var(--color-text-light);
  transition: all 0.3s;
  border: 2px solid transparent;
  cursor: pointer;
}

.simulator-progress-step:disabled {
  cursor: not-allowed;
}

.simulator-progress-step.simulator-active {
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  color: white;
  border-color: #1d4ed8;
  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.15);
  animation: simulator-pulse 2s infinite;
}

.simulator-progress-step.simulator-completed {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border-color: var(--color-success);
  cursor: pointer;
}

.simulator-progress-step.simulator-completed:hover {
  transform: scale(1.05);
}

.simulator-progress-line {
  width: 2.5rem;
  height: 2px;
  background: #e2e8f0;
  margin: 0 0.75rem;
  transition: all 0.3s;
  border-radius: 2px;
}

.simulator-progress-line.simulator-active {
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
}

.simulator-progress-line.simulator-completed {
  background: linear-gradient(135deg, var(--color-success), #047857);
}

.simulator-progress-labels {
  display: flex;
  justify-content: center;
  gap: 3rem;
  font-size: 0.875rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-progress-labels span.simulator-active {
  color: var(--color-primary);
  font-weight: 600;
}

/* ===============================================
   STRUCTURE PRINCIPALE
   =============================================== */
.simulator-app-main {
  flex: 1 1;
}

.simulator-step-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1.5rem;
  animation: simulator-fadeInUp 0.5s ease-out;
}

/* ===============================================
   ÉTAPE 1 - HERO SECTION RESTRUCTURÉE
   =============================================== */
.simulator-step-1 {
  padding: 0;
  margin: 0;
  min-height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
}

.simulator-hero-section {
  width: 100%;
  min-height: 65vh;
  background: linear-gradient(135deg, rgba(30, 64, 175, 0.4), rgba(5, 150, 105, 0.4)), 
              url('https://acfluide-simulateur.acfluide.fr/assets/images/fond.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

.simulator-hero-content {
  text-align: center;
  max-width: 650px;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: var(--shadow-lg);
  margin: 0 1.5rem;
  animation: simulator-fadeInUp 0.8s ease-out;
  position: relative;
  /* CRUCIAL: ASSURER QUE LE CONTENEUR PEUT DÉBORDER */
  overflow: visible !important;
}

.simulator-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #92400e;
  padding: 0.75rem 1rem;
  border-radius: 30px;
  font-weight: 700;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  border: 1px solid var(--color-warning);
}

.simulator-badge-icon {
  width: 1rem;
  height: 1rem;
}

.simulator-hero-title {
  font-size: 2rem;
  font-weight: 800;
  color: var(--color-text);
  margin-bottom: 1.5rem;
  line-height: 1.1;
}

.simulator-highlight-text {
  background: linear-gradient(135deg, var(--color-primary), var(--color-success));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.simulator-hero-subtitle {
  font-size: 1.125rem;
  color: var(--color-text);
  margin-bottom: 2rem;
  line-height: 1.4;
  font-weight: 500;
}

.simulator-subtitle-features {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.simulator-feature-pill {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  color: var(--color-primary);
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.8rem;
  border: 1px solid var(--color-primary);
}

/* ===============================================
   CONTENEUR PRINCIPAL DU FORMULAIRE - NOUVELLE STRUCTURE
   =============================================== */
.simulator-main-form-container {
  max-width: 550px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  /* CRUCIAL: PERMETTRE LE DÉBORDEMENT */
  overflow: visible !important;
  position: relative;
  z-index: 1;
}

/* ===============================================
   SECTION ADRESSE - RESTRUCTURÉE
   =============================================== */
.simulator-address-section {
  /* CRUCIAL: PERMETTRE LE DÉBORDEMENT */
  overflow: visible !important;
  position: relative;
}

.simulator-search-instruction {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: var(--color-text-light);
  font-weight: 600;
  font-size: 0.9rem;
}

.simulator-instruction-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-primary);
}

/* CONTENEUR DE RECHERCHE D'ADRESSE */
.simulator-address-search-container {
  position: relative;
  /* CRUCIAL: PERMETTRE LE DÉBORDEMENT POUR LES SUGGESTIONS */
  overflow: visible !important;
  z-index: var(--z-suggestions);
}

.simulator-address-input-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  position: relative;
  padding: 0 1.25rem;
}

.simulator-address-input-wrapper:focus-within {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
  transform: translateY(-2px);
}

.simulator-search-icon {
  color: #9ca3af;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 1rem;
  flex-shrink: 0;
}

.simulator-address-input {
  flex: 1 1;
  border: none;
  padding: 1rem 0;
  font-size: 1rem;
  outline: none;
  font-weight: 500;
  color: var(--color-text);
  background: transparent;
}

.simulator-address-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.simulator-loading-indicator {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===============================================
   SUGGESTIONS D'ADRESSE - POSITION CORRIGÉE
   =============================================== */
.simulator-address-suggestions {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  right: 0 !important;
  background: white !important;
  border: 2px solid #d1d5db !important;
  border-radius: 8px !important;
  margin-top: 0.25rem !important;
  box-shadow: var(--shadow-lg) !important;
  z-index: 999999 !important;
  max-height: 280px !important;
  overflow-y: auto !important;
  animation: simulator-fadeInUp 0.2s ease-out !important;
  /* ASSURER QUE LES SUGGESTIONS SONT AU-DESSUS DE TOUT */
  transform: translateZ(0) !important;
  /* Forcer l'affichage au-dessus */
  will-change: auto !important;
}

.simulator-suggestion-item {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  position: relative;
}

.simulator-suggestion-item:hover {
  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);
  border-left: 3px solid var(--color-primary);
  transform: translateX(2px);
}

.simulator-suggestion-item:last-child {
  border-bottom: none;
}

.simulator-suggestion-content {
  flex: 1 1;
  text-align: left;
  padding-right: 0.75rem;
}

.simulator-suggestion-label {
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
  line-height: 1.2;
}

.simulator-suggestion-context {
  font-size: 0.8rem;
  color: var(--color-text-light);
}

.simulator-suggestion-arrow {
  color: var(--color-primary);
  font-weight: bold;
  font-size: 1rem;
  opacity: 0;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.simulator-suggestion-item:hover .simulator-suggestion-arrow {
  opacity: 1;
  transform: translateX(2px);
}

/* ===============================================
   SECTION FACTURE ÉLECTRIQUE
   =============================================== */
.simulator-bill-section {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  border: 2px solid #e2e8f0;
  box-shadow: var(--shadow-sm);
}

.simulator-bill-input-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0;
}

.simulator-bill-input {
  font-size: 1.75rem;
  font-weight: 700;
  text-align: center;
  background: var(--color-surface);
  border: 2px solid #e2e8f0;
  border-radius: var(--border-radius);
  padding: 0.5rem 0.75rem;
  width: 7rem;
  outline: none;
  transition: all 0.2s;
}

.simulator-bill-input:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);
}

.simulator-bill-currency {
  font-size: 1.5rem;
  color: var(--color-text-light);
  font-weight: 600;
}

/* Range slider */
.simulator-range-slider {
  width: 100%;
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  outline: none;
  -webkit-appearance: none;
  cursor: pointer;
  margin: 1rem 0;
}

.simulator-range-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  border-radius: 50%;
  cursor: pointer;
}

.simulator-range-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-consumption-stats {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.simulator-stat-item {
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
  padding: 0.75rem 1rem;
  border-radius: 6px;
}

.simulator-stat-item span {
  display: block;
  font-size: 0.8rem;
  color: var(--color-text-light);
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.simulator-stat-item strong {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-primary);
}

/* ===============================================
   SECTION CTA
   =============================================== */
.simulator-cta-section {
  display: flex;
  justify-content: center;
}

.simulator-main-cta-button {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
  min-width: 250px;
}

.simulator-main-cta-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #047857, #065f46);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
}

.simulator-main-cta-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.simulator-btn-text {
  font-weight: 700;
}

.simulator-btn-icon {
  font-size: 1.2rem;
}

/* ===============================================
   MESSAGES DE SUCCÈS
   =============================================== */
.simulator-success-message {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: linear-gradient(135deg, #d1fae5, #a7f3d0);
  color: #065f46;
  padding: 1.25rem;
  border-radius: 10px;
  margin-top: 2rem;
  border: 1px solid #10b981;
  font-weight: 600;
  font-size: 0.9rem;
  animation: simulator-slideInFromBottom 0.5s ease-out;
}

.simulator-success-icon-wrapper {
  width: 2.5rem;
  height: 2.5rem;
  background: #10b981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.simulator-success-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: white;
}

.simulator-success-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.simulator-success-title {
  font-weight: 700;
  font-size: 1rem;
}

.simulator-success-text {
  font-weight: 500;
  opacity: 0.9;
  font-size: 0.875rem;
}

/* ===============================================
   INDICATEURS DE CONFIANCE
   =============================================== */
.simulator-trust-indicators {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}

.simulator-trust-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--color-text-light);
  font-size: 0.875rem;
}

.simulator-trust-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--color-text-light);
  font-size: 0.875rem;
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 0.5rem;
  border-radius: var(--border-radius);
}

.simulator-trust-link:hover {
  background: rgba(30, 64, 175, 0.1);
  color: var(--color-primary);
}

.simulator-rge-logo {
  width: 1.5rem;
  height: auto;
}

.simulator-trust-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-warning);
}

/* ===============================================
   ÉTAPE 2 - LAYOUT DE CONFIGURATION
   =============================================== */
.simulator-content-layout {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 2.5rem;
  margin-top: 1.5rem;
}

.simulator-left-panel {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.simulator-right-panel {
  position: sticky;
  top: 120px;
  height: fit-content;
}

.simulator-section-header {
  text-align: center;
  margin-bottom: 2rem;
}

.simulator-section-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.75rem;
}

.simulator-section-subtitle {
  font-size: 1rem;
  color: var(--color-text-light);
  line-height: 1.4;
  max-width: 450px;
  margin: 0 auto;
}

/* ===============================================
   TOOLTIPS
   =============================================== */
.simulator-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.simulator-tooltip-trigger {
  background: none;
  border: none;
  color: var(--color-primary);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.simulator-tooltip-trigger:hover {
  background: rgba(30, 64, 175, 0.1);
  transform: scale(1.1);
}

.simulator-tooltip-content {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: var(--shadow-lg);
  z-index: var(--z-tooltip);
  width: 280px;
  margin-top: 0.5rem;
  animation: simulator-fadeInUp 0.2s ease-out;
}

.simulator-tooltip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.simulator-tooltip-header h4 {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

.simulator-tooltip-close {
  background: none;
  border: none;
  color: var(--color-text-light);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.simulator-tooltip-close:hover {
  background: #f3f4f6;
  color: var(--color-text);
}

.simulator-tooltip-content p {
  font-size: 0.875rem;
  color: var(--color-text-light);
  line-height: 1.4;
  margin: 0;
}

.simulator-tooltip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

/* ===============================================
   SECTIONS DE CONFIGURATION
   =============================================== */
.simulator-config-section {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: var(--shadow-sm);
}

.simulator-config-section h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 1rem;
  text-align: center;
}

/* ===============================================
   TYPES DE PANNEAUX
   =============================================== */
.simulator-panel-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.simulator-panel-type-card {
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  background: white;
  position: relative;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.simulator-panel-type-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #e2e8f0, #cbd5e1);
  transition: all 0.3s;
}

.simulator-panel-type-card:hover {
  border-color: var(--color-primary);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.simulator-panel-type-card:hover::before {
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
}

.simulator-panel-type-card.simulator-selected {
  border-color: var(--color-success);
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);
  transform: translateY(-2px);
}

.simulator-panel-type-card.simulator-selected::before {
  background: linear-gradient(135deg, var(--color-success), #047857);
}

.simulator-panel-recommendation {
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: linear-gradient(135deg, var(--color-warning), #d97706);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.simulator-panel-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  border: 2px solid white;
  box-shadow: var(--shadow-sm);
}

.simulator-panel-type-name {
  font-weight: 700;
  color: var(--color-text);
  margin: 2rem 0 0.75rem;
  font-size: 1.125rem;
}

.simulator-panel-type-description {
  font-size: 0.9rem;
  color: var(--color-text-light);
  line-height: 1.3;
  margin-bottom: 1.5rem;
}

.simulator-panel-specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.simulator-spec-item {
  background: rgba(248, 250, 252, 0.8);
  padding: 0.75rem 0.5rem;
  border-radius: var(--border-radius);
  text-align: center;
  border: 1px solid #e2e8f0;
}

.simulator-spec-item span {
  display: block;
  font-size: 0.8rem;
  color: var(--color-text-light);
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.simulator-spec-item strong {
  color: var(--color-text);
  font-weight: 700;
  font-size: 0.875rem;
}

/* ===============================================
   OPTIONS DE NOMBRE DE PANNEAUX
   =============================================== */
.simulator-panel-count-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
}

.simulator-panel-count-option {
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem 0.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  position: relative;
  margin-top: 1rem;
  box-shadow: var(--shadow-sm);
}

.simulator-panel-count-option:hover {
  border-color: var(--color-primary);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.simulator-panel-count-option.simulator-selected {
  border-color: var(--color-success);
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.15);
}

.simulator-panel-count-number {
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  line-height: 1.2;
}

.simulator-panel-count-power {
  font-size: 1rem;
  color: var(--color-primary);
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.simulator-panel-count-production {
  font-size: 0.75rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-popular-badge {
  position: absolute;
  top: -0.75rem;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, var(--color-warning), #d97706);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
  z-index: 10;
}

/* ===============================================
   SECTION BATTERIES
   =============================================== */
.simulator-battery-subtitle {
  font-size: 0.9rem;
  color: var(--color-text-light);
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

.simulator-battery-types-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.simulator-battery-type-card {
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: white;
  position: relative;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  min-height: 380px;
  display: flex;
  flex-direction: column;
}

.simulator-battery-type-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #e2e8f0;
  transition: all 0.3s;
}

.simulator-battery-type-card:hover {
  border-color: var(--color-primary);
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
}

.simulator-battery-type-card:hover::before {
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
}

.simulator-battery-type-card.simulator-selected {
  border-color: var(--color-success);
  background: linear-gradient(135deg, rgba(236, 253, 245, 0.8), rgba(209, 250, 229, 0.8));
  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);
}

.simulator-battery-type-card.simulator-selected::before {
  background: linear-gradient(135deg, var(--color-success), #047857);
}

.simulator-battery-type-card.simulator-recommended {
  border-color: var(--color-warning);
  background: linear-gradient(135deg, rgba(254, 243, 199, 0.6), rgba(253, 230, 138, 0.6));
}

.simulator-battery-type-card.simulator-recommended::before {
  background: linear-gradient(135deg, var(--color-warning), #d97706);
}

.simulator-recommendation-badge {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: linear-gradient(135deg, var(--color-warning), #d97706);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  box-shadow: var(--shadow-sm);
}

.simulator-battery-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.simulator-battery-icon {
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.simulator-battery-info h4 {
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.375rem;
  font-size: 1rem;
}

.simulator-battery-info p {
  color: var(--color-text-light);
  font-size: 0.825rem;
  line-height: 1.3;
  margin: 0;
}

.simulator-battery-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.simulator-battery-stat {
  background: rgba(248, 250, 252, 0.8);
  padding: 0.625rem;
  border-radius: var(--border-radius);
  text-align: center;
  border: 1px solid #e2e8f0;
}

.simulator-battery-stat span {
  display: block;
  font-size: 0.75rem;
  color: var(--color-text-light);
  margin-bottom: 0.375rem;
  font-weight: 500;
}

.simulator-battery-stat strong {
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-text);
}

.simulator-autoconso-rate {
  color: var(--color-success) !important;
}

.simulator-battery-details {
  margin-bottom: 0.75rem;
  flex: 1 1;
}

.simulator-advantages,
.simulator-disadvantages {
  margin-bottom: 0.75rem;
}

.simulator-advantages h5,
.simulator-disadvantages h5 {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.375rem;
  color: var(--color-text);
}

.simulator-advantages h5 {
  color: var(--color-success);
}

.simulator-disadvantages h5 {
  color: #dc2626;
}

.simulator-advantages ul,
.simulator-disadvantages ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.simulator-advantages li,
.simulator-disadvantages li {
  font-size: 0.75rem;
  color: var(--color-text-light);
  margin-bottom: 0.2rem;
  padding-left: 1rem;
  position: relative;
  line-height: 1.2;
}

.simulator-advantages li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--color-success);
  font-weight: bold;
}

.simulator-disadvantages li::before {
  content: '⚠';
  position: absolute;
  left: 0;
  color: #dc2626;
  font-weight: bold;
}

.simulator-battery-learn-more {
  background: #eff6ff;
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  width: 100%;
  justify-content: center;
}

.simulator-battery-learn-more:hover {
  background: var(--color-primary);
  color: white;
}

/* ===============================================
   CONFIGURATION BATTERIE PHYSIQUE
   =============================================== */
.simulator-battery-config {
  border-top: 1px solid #d1fae5;
  padding-top: 1.25rem;
  margin-top: 1rem;
}

.simulator-power-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.simulator-power-header label {
  font-weight: 600;
  color: var(--color-text);
  font-size: 1rem;
}

.simulator-power-value {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--color-primary);
}

.simulator-battery-benefit {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #92400e;
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-top: 0.75rem;
  font-weight: 600;
  text-align: center;
  font-size: 0.9rem;
}

/* ===============================================
   APERÇU ÉCONOMIES
   =============================================== */
.simulator-economy-preview {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.simulator-economy-comparison {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  align-items: center;
}

.simulator-economy-before,
.simulator-economy-after {
  text-align: center;
  padding: 1rem;
  border-radius: 8px;
}

.simulator-economy-before {
  background: linear-gradient(135deg, #fef2f2, #fee2e2);
  border: 1px solid var(--color-danger);
}

.simulator-economy-after {
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  border: 1px solid var(--color-success);
}

.simulator-economy-before span,
.simulator-economy-after span {
  display: block;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.simulator-amount {
  font-size: 1.5rem;
  font-weight: 800;
  margin-bottom: 0.25rem;
}

.simulator-amount.current {
  color: var(--color-danger);
}

.simulator-amount.savings {
  color: var(--color-success);
}

.simulator-economy-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.simulator-arrow-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: var(--color-primary);
}

.simulator-economy-arrow span {
  font-size: 0.75rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-savings-badge {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}

/* ===============================================
   CALCUL PVGIS - LOADING AMÉLIORÉ
   =============================================== */
.simulator-pvgis-loading-enhanced {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-radius: 12px;
  border: 2px solid #e2e8f0;
}

.simulator-pvgis-animation {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
  max-width: 400px;
}

.simulator-calculation-steps {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
}

.simulator-calculation-step {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: var(--border-radius);
  background: rgba(248, 250, 252, 0.8);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  font-size: 0.875rem;
  font-weight: 500;
}

.simulator-calculation-step.simulator-completed {
  background: rgba(5, 150, 105, 0.1);
  border: 1px solid var(--color-success);
  color: var(--color-success);
}

.simulator-calculation-step.simulator-active {
  background: rgba(30, 64, 175, 0.1);
  border: 1px solid var(--color-primary);
  animation: simulator-glow 1.5s infinite;
  color: var(--color-primary);
}

.simulator-calculation-step.simulator-pending {
  background: rgba(148, 163, 184, 0.1);
  border: 1px solid #94a3b8;
  color: #64748b;
}

.simulator-step-icon {
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.simulator-calculation-step.simulator-completed .simulator-step-icon {
  color: var(--color-success);
}

.simulator-calculation-step.simulator-active .simulator-step-icon {
  color: var(--color-primary);
}

.simulator-calculation-step.simulator-pending .simulator-step-icon {
  color: #94a3b8;
}

.simulator-calculation-description {
  text-align: center;
}

.simulator-calculation-description h4 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 0.5rem;
}

.simulator-calculation-description p {
  font-size: 0.9rem;
  color: var(--color-text-light);
  margin: 0;
}

/* ===============================================
   SECTION LOA
   =============================================== */
.simulator-leasing-subtitle {
  font-size: 0.9rem;
  color: var(--color-text-light);
  text-align: center;
  margin-bottom: 1.5rem;
}

.simulator-leasing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
}

.simulator-leasing-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  box-shadow: var(--shadow-sm);
  margin-top: 1rem;
}

.simulator-leasing-card:hover {
  border-color: var(--color-primary);
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
}

.simulator-leasing-card.simulator-selected {
  border-color: var(--color-success);
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);
}

.simulator-leasing-card.simulator-popular {
  border-color: var(--color-warning);
  background: linear-gradient(135deg, #fef3c7, #fde68a);
}

.simulator-leasing-duration {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.25rem;
  margin-bottom: 1rem;
}

.simulator-years {
  font-size: 2rem;
  font-weight: 800;
  color: var(--color-text);
  line-height: 1;
}

.simulator-years-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text-light);
}

.simulator-leasing-details {
  margin-bottom: 1rem;
}

.simulator-monthly-amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.25rem;
}

.simulator-amount-value {
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--color-primary);
}

.simulator-amount-label {
  font-size: 0.8rem;
  color: var(--color-text-light);
  font-weight: 500;
}

/* ===============================================
   OPTIONS ET TOGGLES
   =============================================== */
.simulator-option-card {
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  transition: all 0.2s;
  background: white;
  box-shadow: var(--shadow-sm);
}

.simulator-option-card.simulator-active {
  border-color: var(--color-success);
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
}

.simulator-option-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.simulator-option-info {
  display: flex;
  gap: 1rem;
  flex: 1 1;
}

.simulator-option-icon {
  width: 2.5rem;
  height: 2.5rem;
  color: var(--color-primary);
  flex-shrink: 0;
}

.simulator-option-info h4 {
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
}

.simulator-option-info p {
  color: var(--color-text-light);
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.simulator-info-link {
  background: none;
  border: none;
  color: var(--color-primary);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.875rem;
  text-decoration: underline;
}

/* Toggle Switch */
.simulator-toggle {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.simulator-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.simulator-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e2e8f0;
  transition: 0.3s;
  border-radius: 8px;
}

.simulator-toggle-slider:before {
  position: absolute;
  content: "";
  height: 1.25rem;
  width: 1.25rem;
  left: 0.125rem;
  bottom: 0.125rem;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.simulator-toggle input:checked + .simulator-toggle-slider {
  background: linear-gradient(135deg, var(--color-success), #047857);
}

.simulator-toggle input:checked + .simulator-toggle-slider:before {
  transform: translateX(1.5rem);
}

.simulator-charging-benefit {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #92400e;
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-top: 0.75rem;
  font-weight: 600;
  text-align: center;
  font-size: 0.9rem;
}

.simulator-option-price {
  text-align: center;
  margin-top: 1rem;
}

.simulator-price-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--color-surface);
  padding: 1rem;
  border-radius: var(--border-radius);
  margin-bottom: 0.75rem;
}

.simulator-price-details strong {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-success);
}

/* ===============================================
   SERVICES INCLUS
   =============================================== */
.simulator-services-section {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 2rem;
  margin: 2rem 0;
}

.simulator-services-section h3 {
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 1.5rem;
  text-align: center;
}

.simulator-services-grid {
  display: grid;
  gap: 1.5rem;
}

.simulator-service-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  transition: all 0.2s ease;
}

.simulator-service-card:hover {
  border-color: var(--color-primary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.simulator-service-icon {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.simulator-service-content {
  flex: 1 1;
}

.simulator-service-content h4 {
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
}

.simulator-service-content p {
  color: var(--color-text-light);
  line-height: 1.4;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.simulator-service-content ul {
  margin: 0.5rem 0 1rem 1rem;
  color: var(--color-text-light);
  font-size: 0.9rem;
}

.simulator-service-content li {
  margin-bottom: 0.25rem;
}

.simulator-service-included {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(5, 150, 105, 0.1);
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-weight: 600;
  color: #065f46;
  font-size: 0.875rem;
}

.simulator-service-benefit {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(30, 64, 175, 0.1);
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-weight: 600;
  color: var(--color-primary);
  font-size: 0.875rem;
}

.simulator-check-icon,
.simulator-benefit-icon {
  width: 1rem;
  height: 1rem;
}

/* ===============================================
   SECTIONS INFO ET CTA
   =============================================== */
.simulator-info-section {
  margin: 2rem 0;
}

.simulator-info-card {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border: 2px solid var(--color-primary);
  border-radius: 10px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.simulator-info-icon {
  width: 2rem;
  height: 2rem;
  color: var(--color-primary);
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.simulator-info-content h4 {
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.simulator-info-content p {
  color: var(--color-text-light);
  line-height: 1.4;
  font-size: 0.9rem;
  margin: 0;
}

.simulator-cta-section {
  display: flex;
  justify-content: center;
}

.simulator-cta-card {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border: 2px solid var(--color-primary);
  border-radius: 16px;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-lg);
}

.simulator-cta-content h3 {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--color-text);
  margin-bottom: 1rem;
}

.simulator-cta-content p {
  font-size: 1.125rem;
  color: var(--color-text-light);
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.simulator-cta-benefits {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 2rem;
  align-items: flex-start;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.simulator-cta-benefit {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  color: var(--color-text);
  font-size: 1rem;
}

.simulator-cta-check {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--color-success);
  background: rgba(5, 150, 105, 0.1);
  border-radius: 50%;
  padding: 0.125rem;
  flex-shrink: 0;
}

.simulator-main-cta-btn {
  background: linear-gradient(135deg, var(--color-primary), #1d4ed8);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
  margin: 0 auto;
}

.simulator-main-cta-btn:hover {
  background: linear-gradient(135deg, #1d4ed8, #1e3a8a);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.4);
}

.simulator-cta-arrow {
  width: 1rem;
  height: 1rem;
  transition: transform 0.2s ease;
}

.simulator-main-cta-btn:hover .simulator-cta-arrow {
  transform: translateX(2px);
}

/* ===============================================
   PANNEAU DROIT - RÉCAPITULATIF
   =============================================== */
.simulator-view-mode-switch {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border: 2px solid var(--color-primary);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.simulator-switch-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.simulator-switch-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text-light);
  transition: all 0.2s ease;
}

.simulator-switch-label.active {
  color: var(--color-primary);
  font-weight: 700;
}

.simulator-toggle-switch {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.simulator-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.simulator-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e2e8f0;
  transition: 0.3s;
  border-radius: 12px;
}

.simulator-switch-slider:before {
  position: absolute;
  content: "";
  height: 1.125rem;
  width: 1.125rem;
  left: 0.1875rem;
  bottom: 0.1875rem;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.simulator-toggle-switch input:checked + .simulator-switch-slider {
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
}

.simulator-toggle-switch input:checked + .simulator-switch-slider:before {
  transform: translateX(1.5rem);
}

.simulator-price-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
}

.simulator-price-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  justify-content: center;
}

.simulator-sparkle-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--color-warning);
}

.simulator-price-header span {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-text);
}

.simulator-new-bill-highlight {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border-radius: 10px;
  padding: 1.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
}

.simulator-highlight-label {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 0.75rem;
}

.simulator-new-bill-amount {
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.simulator-old-bill-crossed {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-bottom: 0.75rem;
}

.simulator-old-bill-crossed span {
  text-decoration: line-through;
  opacity: 0.7;
}

.simulator-economy-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
}

.simulator-economy-icon {
  width: 1rem;
  height: 1rem;
}

.simulator-bill-disclaimer {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin-top: 0.5rem;
  font-style: italic;
}

.simulator-price-breakdown {
  margin-bottom: 1.5rem;
}

.simulator-price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.simulator-price-item span {
  color: var(--color-text-light);
  font-weight: 500;
  font-size: 0.9rem;
}

.simulator-price-item strong {
  font-weight: 700;
  color: var(--color-text);
  font-size: 1rem;
}

.simulator-savings-text {
  color: var(--color-success) !important;
}

.simulator-price-total {
  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);
  padding: 1rem;
  border-radius: var(--border-radius);
  margin-top: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.simulator-net-impact {
  font-size: 1.25rem;
  font-weight: 800;
}

.simulator-net-impact.positive {
  color: var(--color-success);
}

.simulator-net-impact.negative {
  color: var(--color-danger);
}

.simulator-leasing-selected {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #eff6ff;
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1.5rem;
}

.simulator-clock-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-primary);
}

.simulator-leasing-selected span {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-primary);
}

.simulator-benefits-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.simulator-benefit-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--color-text);
  font-size: 0.9rem;
}

.simulator-check-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-success);
}

.simulator-long-term-savings {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border: 2px solid var(--color-warning);
  border-radius: 10px;
  padding: 1.5rem;
  margin: 1.5rem 0;
  text-align: center;
}

.simulator-long-term-savings h4 {
  font-weight: 700;
  color: #92400e;
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
}

.simulator-savings-value {
  font-size: 1.75rem;
  font-weight: 800;
  color: #92400e;
  margin-bottom: 0.5rem;
}

.simulator-long-term-savings p {
  font-size: 0.8rem;
  color: #92400e;
  opacity: 0.8;
  margin: 0;
}

.simulator-production-highlight {
  margin: 1.5rem 0;
}

.simulator-production-card {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  color: white;
  border-radius: 10px;
  padding: 1.5rem;
}

.simulator-production-icon {
  width: 3rem;
  height: 3rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.simulator-production-details {
  flex: 1 1;
}

.simulator-production-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  opacity: 0.9;
}

.simulator-production-value {
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.simulator-production-subtitle {
  font-size: 0.875rem;
  font-weight: 600;
  opacity: 0.95;
}

.simulator-right-panel-cta {
  margin-top: 1.5rem;
  text-align: center;
}

.simulator-devis-cta-btn {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);
}

.simulator-devis-cta-btn:hover {
  background: linear-gradient(135deg, #047857, #065f46);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);
}

.simulator-cta-disclaimer {
  font-size: 0.8rem;
  color: var(--color-text-light);
  margin-top: 0.5rem;
  font-style: italic;
}

.simulator-price-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  text-align: center;
}

.simulator-price-loading .simulator-loading-spinner {
  width: 2rem;
  height: 2rem;
  border: 2px solid rgba(30, 64, 175, 0.3);
  border-top: 2px solid var(--color-primary);
  border-radius: 50%;
  animation: simulator-spin 1s linear infinite;
  margin-bottom: 1rem;
}

.simulator-price-loading p {
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-primary);
  margin: 0 0 0.5rem 0;
}

.simulator-price-loading span {
  font-size: 0.875rem;
  color: var(--color-text-light);
  font-weight: 500;
}

/* ===============================================
   SERVICE DETAILS BUTTON
   =============================================== */
.simulator-service-details-btn {
  background: #eff6ff;
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.simulator-service-details-btn:hover {
  background: var(--color-primary);
  color: white;
}

/* ===============================================
   ÉTAPE 3 - FORMULAIRE DE CONTACT
   =============================================== */
.simulator-contact-hero {
  text-align: center;
  margin-bottom: 2.5rem;
}

.simulator-contact-icon {
  width: 3.5rem;
  height: 3.5rem;
  background: linear-gradient(135deg, var(--color-success), #047857);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: white;
}

.simulator-contact-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--color-text);
  margin-bottom: 0.75rem;
}

.simulator-contact-subtitle {
  font-size: 1.125rem;
  color: var(--color-text-light);
  line-height: 1.4;
}

.simulator-savings-preview-big {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1.25rem;
  margin: 2rem 0;
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
}

.simulator-preview-item {
  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);
  border: 1px solid #e2e8f0;
  border-radius: var(--border-radius);
  padding: 1.25rem 1rem;
  text-align: center;
}

.simulator-preview-item span {
  display: block;
  font-size: 0.875rem;
  color: var(--color-text-light);
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.simulator-preview-item strong {
  font-size: 1.375rem;
  font-weight: 800;
}

.simulator-preview-item strong.simulator-positive {
  color: var(--color-success);
}

.simulator-contact-form {
  max-width: 550px;
  margin: 0 auto;
}

.simulator-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.simulator-form-group {
  margin-bottom: 1.25rem;
}

.simulator-form-label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.simulator-form-input {
  width: 100%;
  padding: 0.875rem;
  border: 2px solid #e2e8f0;
  border-radius: var(--border-radius);
  font-size: 0.9rem;
  outline: none;
  transition: all 0.2s;
  font-weight: 500;
}

.simulator-form-input:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);
}

.simulator-input-with-icon {
  position: relative;
}

.simulator-input-icon {
  position: absolute;
  left: 0.875rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.125rem;
  height: 1.125rem;
  color: #9ca3af;
}

.simulator-input-with-icon-field {
  padding-left: 2.5rem;
}

.simulator-input-with-prefix {
  display: flex;
  border: 2px solid #e2e8f0;
  border-radius: var(--border-radius);
  overflow: hidden;
  transition: all 0.2s;
}

.simulator-input-with-prefix:focus-within {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);
}

.simulator-phone-prefix {
  background: var(--color-surface);
  padding: 0.875rem;
  color: var(--color-text-light);
  font-weight: 600;
  border-right: 1px solid #e2e8f0;
  font-size: 0.875rem;
}

.simulator-phone-input {
  border: none;
  flex: 1 1;
  padding: 0.875rem;
  font-size: 0.9rem;
  outline: none;
  font-weight: 500;
}

.simulator-consent-box {
  background: linear-gradient(135deg, #dbeafe, #bfdbfe);
  border-radius: var(--border-radius);
  padding: 1.25rem;
  margin: 1.25rem 0;
  border: 1px solid var(--color-primary);
}

.simulator-consent-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  gap: 0.75rem;
}

.simulator-consent-checkbox {
  margin-top: 0.125rem;
  width: 1.125rem;
  height: 1.125rem;
  accent-color: var(--color-primary);
}

.simulator-consent-label span {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--color-primary);
}

/* ===============================================
   TIMELINE
   =============================================== */
.simulator-timeline {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border-radius: 10px;
  padding: 2rem;
  margin-top: 2rem;
  border: 2px solid var(--color-warning);
}

.simulator-timeline-title {
  font-weight: 700;
  color: #92400e;
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
  text-align: center;
}

.simulator-timeline-steps {
  display: grid;
  gap: 1.25rem;
  margin-bottom: 1.5rem;
}

.simulator-timeline-step {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.simulator-timeline-step.simulator-done .simulator-timeline-icon {
  background: var(--color-success);
}

.simulator-timeline-step.simulator-next .simulator-timeline-icon {
  background: var(--color-primary);
  animation: simulator-pulse 2s infinite;
}

.simulator-timeline-step.simulator-future .simulator-timeline-icon {
  background: #94a3b8;
}

.simulator-timeline-icon {
  width: 2.5rem;
  height: 2.5rem;
  background: var(--color-warning);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
  flex-shrink: 0;
}

.simulator-status-check {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  width: 1rem;
  height: 1rem;
  background: var(--color-success);
  border-radius: 50%;
  border: 2px solid white;
}

.simulator-timeline-content {
  flex: 1 1;
}

.simulator-timeline-step-title {
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.25rem;
  font-size: 1rem;
}

.simulator-timeline-step-time {
  font-size: 0.875rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-contact-support {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  padding: 1.25rem;
  border: 1px solid rgba(146, 64, 14, 0.2);
}

.simulator-support-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.simulator-support-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: var(--color-primary);
}

.simulator-support-header h5 {
  font-weight: 600;
  color: var(--color-text);
  font-size: 1rem;
  margin: 0;
}

.simulator-support-contacts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.simulator-support-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--color-surface);
  padding: 1rem;
  border-radius: var(--border-radius);
  border: 1px solid #e2e8f0;
}

.simulator-support-item-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-primary);
  flex-shrink: 0;
}

.simulator-support-item div {
  display: flex;
  flex-direction: column;
}

.simulator-support-label {
  font-size: 0.8rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-support-value {
  font-weight: 700;
  color: var(--color-text);
  font-size: 0.875rem;
}

.simulator-support-hours {
  text-align: center;
  font-size: 0.875rem;
  color: var(--color-text-light);
  font-weight: 500;
  margin: 0;
}

/* ===============================================
   ÉTAPE 4 - OFFRE FINALE
   =============================================== */
.simulator-offer-hero {
  text-align: center;
  margin-bottom: 2.5rem;
}

.simulator-offer-icon {
  width: 3.5rem;
  height: 3.5rem;
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: white;
}

.simulator-offer-title {
  font-size: 2rem;
  font-weight: 800;
  color: var(--color-text);
  margin-bottom: 0.75rem;
}

.simulator-offer-subtitle {
  font-size: 1.125rem;
  color: var(--color-text-light);
}

.simulator-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.5rem 0;
  gap: 1.25rem;
}

.simulator-loading-spinner {
  width: 3rem;
  height: 3rem;
  border: 3px solid #e2e8f0;
  border-top: 3px solid var(--color-primary);
  border-radius: 50%;
  animation: simulator-spin 1s linear infinite;
}

.simulator-loading p {
  font-size: 1rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-offer-content {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 2.5rem;
}

.simulator-main-savings-highlight {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border-radius: 10px;
  padding: 2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.simulator-main-savings-highlight h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
  opacity: 0.95;
}

.simulator-savings-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
}

.simulator-savings-main span {
  display: block;
  font-size: 1rem;
  opacity: 0.9;
  margin-bottom: 0.75rem;
  font-weight: 500;
}

.simulator-new-bill-mega {
  font-size: 2.75rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.simulator-old-bill-mega {
  font-size: 1.125rem;
  opacity: 0.8;
  text-decoration: line-through;
}

.simulator-bill-disclaimer-main {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 0.5rem;
}

.simulator-savings-details {
  display: grid;
  gap: 0.75rem;
}

.simulator-saving-detail {
  background: rgba(255, 255, 255, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.simulator-saving-detail span {
  opacity: 0.9;
  font-weight: 500;
  font-size: 0.9rem;
}

.simulator-saving-detail strong {
  font-weight: 700;
  font-size: 1rem;
}

.simulator-saving-detail strong.simulator-positive {
  color: #a7f3d0;
}

.simulator-installation-summary {
  background: linear-gradient(135deg, var(--color-primary), #7c3aed);
  border-radius: 10px;
  padding: 2rem;
  color: white;
  margin-bottom: 2rem;
}

.simulator-installation-summary .simulator-section-title {
  color: white;
  text-align: left;
}

.simulator-summary-grid {
  display: grid;
  gap: 1.25rem;
  margin-top: 1.25rem;
}

.simulator-summary-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 1.25rem;
  border-radius: var(--border-radius);
}

.simulator-summary-icon {
  width: 2.5rem;
  height: 2.5rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.simulator-summary-item div h4 {
  font-weight: 700;
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
}

.simulator-summary-item div p {
  opacity: 0.9;
  font-size: 0.875rem;
  margin: 0.25rem 0;
}

/* ===============================================
   SERVICES INCLUS - ÉTAPE 4
   =============================================== */
.simulator-services-included {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.simulator-services-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.simulator-services-header .simulator-section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.75rem;
}

.simulator-services-grid-enhanced {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.25rem;
  margin-bottom: 1.5rem;
}

.simulator-service-item-enhanced {
  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem;
  transition: all 0.3s ease;
}

.simulator-service-item-enhanced:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
  border-color: var(--color-primary);
}

.simulator-service-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.simulator-service-icon-wrapper {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.simulator-service-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: white;
}

.simulator-included-badge-new {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 15px;
  font-weight: 700;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.simulator-check-icon-small {
  width: 0.875rem;
  height: 0.875rem;
}

.simulator-service-content h4 {
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
}

.simulator-service-description {
  color: var(--color-text-light);
  line-height: 1.4;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.simulator-premium-guarantee {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border: 2px solid var(--color-warning);
  border-radius: 10px;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.simulator-guarantee-icon {
  width: 3rem;
  height: 3rem;
  background: var(--color-warning);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.simulator-guarantee-icon-svg {
  width: 1.5rem;
  height: 1.5rem;
  color: white;
}

.simulator-guarantee-content h4 {
  font-weight: 700;
  color: #92400e;
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
}

.simulator-guarantee-features {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.simulator-guarantee-features span {
  background: rgba(255, 255, 255, 0.8);
  padding: 0.25rem 0.5rem;
  border-radius: var(--border-radius);
  font-size: 0.875rem;
  font-weight: 600;
  color: #92400e;
}

.simulator-rge-certification {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(146, 64, 14, 0.2);
}

.simulator-rge-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.9);
  padding: 0.75rem 1rem;
  border-radius: var(--border-radius);
  text-decoration: none;
  color: #92400e;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.simulator-rge-badge:hover {
  background: white;
  transform: translateY(-1px);
}

.simulator-rge-cert-logo {
  width: 1.5rem;
  height: auto;
}

/* ===============================================
   IMPACT ENVIRONNEMENTAL
   =============================================== */
.simulator-environmental-impact {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  border: 1px solid var(--color-success);
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.simulator-environmental-icon {
  width: 3rem;
  height: 3rem;
  color: var(--color-success);
  flex-shrink: 0;
}

.simulator-environmental-impact h3 {
  font-weight: 700;
  color: #065f46;
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
}

.simulator-environmental-impact p {
  color: #065f46;
  font-weight: 500;
  line-height: 1.4;
  margin: 0.375rem 0;
  font-size: 0.9rem;
}

.simulator-final-cta-container {
  text-align: center;
}

.simulator-cta-subtitle {
  margin-top: 0.75rem;
  color: var(--color-text-light);
  font-weight: 500;
  font-size: 0.875rem;
}

/* ===============================================
   RÉCAPITULATIF PRIX - ÉTAPE 4
   =============================================== */
.simulator-pricing-summary {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
}

.simulator-summary-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.simulator-summary-star {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--color-warning);
}

.simulator-summary-header h3 {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--color-text);
}

.simulator-bill-transformation {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.simulator-transformation-title {
  font-size: 0.875rem;
  opacity: 0.9;
  margin-bottom: 1rem;
  font-weight: 500;
}

.simulator-bill-before-after {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.75rem;
}

.simulator-bill-old,
.simulator-bill-new {
  text-align: center;
}

.simulator-bill-old span,
.simulator-bill-new span {
  display: block;
  font-size: 0.8rem;
  opacity: 0.8;
  margin-bottom: 0.375rem;
}

.simulator-amount-old {
  font-size: 1.25rem;
  font-weight: 700;
  opacity: 0.7;
  text-decoration: line-through;
}

.simulator-amount-new {
  font-size: 1.75rem;
  font-weight: 800;
}

.simulator-transformation-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.simulator-arrow {
  width: 1.25rem;
  height: 1.25rem;
}

.simulator-monthly-savings {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.5rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  font-size: 0.875rem;
}

.simulator-bill-disclaimer-summary {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 0.375rem;
}

.simulator-pricing-details {
  margin-bottom: 1.5rem;
}

.simulator-detail-section {
  margin-bottom: 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 1rem;
}

.simulator-detail-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.simulator-detail-section h4 {
  font-weight: 600;
  color: var(--color-text);
  margin-bottom: 0.75rem;
  font-size: 1rem;
}

.simulator-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.simulator-detail-item span:first-child {
  color: var(--color-text-light);
  font-weight: 500;
  font-size: 0.875rem;
}

.simulator-detail-item span:last-child {
  font-weight: 600;
  color: var(--color-text);
  font-size: 0.875rem;
}

.simulator-detail-item.simulator-prominent {
  background: var(--color-surface);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  border: 1px solid #e2e8f0;
}

.simulator-detail-item.simulator-prominent span:last-child {
  color: var(--color-primary);
  font-size: 1rem;
  font-weight: 700;
}

.simulator-savings-amount {
  color: var(--color-success) !important;
  font-weight: 700 !important;
}

.simulator-guarantee-badges {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.simulator-badge-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  background: var(--color-surface);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  text-align: center;
  border: 1px solid #e2e8f0;
}

.simulator-badge-icon {
  width: 1.125rem;
  height: 1.125rem;
  color: var(--color-primary);
}

.simulator-badge-item span {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-text-light);
}

.simulator-contact-expert {
  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);
  border-radius: 10px;
  padding: 1.25rem;
  text-align: center;
  margin-top: 1.25rem;
  border: 2px solid #e2e8f0;
}

.simulator-expert-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  justify-content: center;
}

.simulator-expert-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: var(--color-primary);
}

.simulator-expert-header div {
  text-align: left;
}

.simulator-expert-header p {
  margin: 0;
  color: var(--color-text-light);
  font-weight: 500;
  font-size: 0.875rem;
}

.simulator-expert-subtitle {
  font-size: 0.8rem;
  color: var(--color-primary);
  font-weight: 600;
}

.simulator-expert-contacts {
  display: grid;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.simulator-expert-contact {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: white;
  padding: 0.875rem;
  border-radius: var(--border-radius);
  border: 1px solid #e2e8f0;
}

.simulator-phone-icon {
  width: 1rem;
  height: 1rem;
  color: var(--color-primary);
  flex-shrink: 0;
}

.simulator-contact-details {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1 1;
}

.simulator-contact-type {
  font-size: 0.8rem;
  color: var(--color-text-light);
  font-weight: 500;
}

.simulator-contact-details strong {
  font-size: 0.875rem;
  color: var(--color-text);
  font-weight: 700;
}

.simulator-expert-hours {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(30, 64, 175, 0.1);
  padding: 0.5rem;
  border-radius: var(--border-radius);
  font-size: 0.8rem;
  color: var(--color-primary);
  font-weight: 500;
}

.simulator-hours-icon {
  width: 0.875rem;
  height: 0.875rem;
}

/* ===============================================
   STICKY FOOTER NAVIGATION
   =============================================== */
.simulator-sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, var(--color-primary), #1d4ed8);
  color: white;
  box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);
  z-index: var(--z-sticky);
}

.simulator-sticky-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 2rem;
  align-items: center;
}

.simulator-sticky-nav-left {
  display: flex;
  align-items: center;
}

.simulator-nav-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  font-size: 0.875rem;
}

.simulator-nav-btn.simulator-prev {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  backdrop-filter: blur(10px);
}

.simulator-nav-btn.simulator-prev:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateX(-2px);
}

.simulator-sticky-savings {
  text-align: center;
  flex: 1 1;
}

.simulator-sticky-title {
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.875rem;
}

.simulator-sticky-bills-comparison {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
}

.simulator-sticky-bill-old,
.simulator-sticky-bill-new {
  text-align: center;
}

.simulator-sticky-bill-old span,
.simulator-sticky-bill-new span {
  display: block;
  font-size: 0.75rem;
  opacity: 0.8;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  font-weight: 500;
}

.simulator-sticky-amount-old {
  font-size: 1.125rem;
  font-weight: 600;
  color: #fca5a5;
  text-decoration: line-through;
  opacity: 0.8;
}

.simulator-sticky-amount-new {
  font-size: 1.375rem;
  font-weight: 800;
  color: #86efac;
}

.simulator-sticky-arrow {
  font-size: 1rem;
  color: #86efac;
  font-weight: bold;
  margin: 0 0.375rem;
}

.simulator-sticky-pricing {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.simulator-sticky-price {
  text-align: right;
}

.simulator-sticky-label {
  display: block;
  font-size: 0.8rem;
  opacity: 0.8;
  margin-bottom: 0.25rem;
}

.simulator-sticky-amount {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
}

.simulator-sticky-cta {
  background: linear-gradient(135deg, var(--color-success), #047857);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: var(--border-radius);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.simulator-sticky-cta:hover:not(:disabled) {
  background: linear-gradient(135deg, #047857, #065f46);
  transform: translateY(-1px);
}

.simulator-sticky-cta:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===============================================
   MODALES
   =============================================== */
.simulator-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  padding: 1.5rem;
}

.simulator-modal-content {
  background: white;
  border-radius: 10px;
  max-width: 450px;
  width: 100%;
  max-height: 75vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  animation: simulator-fadeInUp 0.3s ease-out;
}

.simulator-modal-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.25rem 1rem;
  border-bottom: 1px solid #f1f5f9;
}

.simulator-modal-icon {
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, var(--color-primary), #2563eb);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.simulator-modal-header h3 {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  flex: 1 1;
}

.simulator-modal-close {
  background: none;
  border: none;
  color: var(--color-text-light);
  cursor: pointer;
  padding: 0.375rem;
  border-radius: var(--border-radius);
  transition: all 0.2s;
}

.simulator-modal-close:hover {
  background: #f1f5f9;
  color: var(--color-text);
}

.simulator-modal-body {
  padding: 1rem 1.25rem 1.25rem;
}

.simulator-modal-body p {
  color: var(--color-text-light);
  line-height: 1.5;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.simulator-modal-details {
  background: var(--color-surface);
  padding: 1rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}

.simulator-modal-details p {
  margin: 0;
  color: var(--color-text);
  font-size: 0.9rem;
}

.simulator-modal-price,
.simulator-modal-included {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: var(--border-radius);
  padding: 1rem;
  text-align: center;
  justify-content: center;
}

.simulator-modal-price {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
}

.simulator-modal-included {
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  border: 1px solid var(--color-success);
  color: #065f46;
}

.simulator-price-icon,
.simulator-check-icon {
  width: 1.125rem;
  height: 1.125rem;
}

/* ===============================================
   FOOTER
   =============================================== */
.simulator-app-footer {
  background: linear-gradient(135deg, #1f2937, #374151);
  color: white;
  margin-top: 0;
}

.simulator-footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 1.25rem;
}

.simulator-footer-main {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 2.5rem;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #4b5563;
}

.simulator-footer-company {
  max-width: 350px;
}

.simulator-footer-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.simulator-footer-logo-image {
  width: 2rem;
  height: auto;
}

.simulator-footer-logo div {
  display: flex;
  flex-direction: column;
}

.simulator-footer-logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.simulator-footer-tagline {
  font-size: 0.75rem;
  color: #9ca3af;
  font-weight: 500;
}

.simulator-footer-description {
  color: #d1d5db;
  line-height: 1.5;
  font-size: 0.9rem;
}

.simulator-footer-contact h4,
.simulator-footer-certifications h4 {
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
  font-size: 1.125rem;
}

.simulator-footer-contact-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.simulator-footer-contact-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.simulator-footer-icon {
  width: 1.125rem;
  height: 1.125rem;
  color: #60a5fa;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.simulator-footer-contact-item div {
  display: flex;
  flex-direction: column;
}

.simulator-contact-label {
  font-size: 0.8rem;
  color: #9ca3af;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.simulator-contact-value {
  color: #f3f4f6;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
}

.simulator-cert-badges {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.simulator-cert-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 0.75rem;
  border-radius: var(--border-radius);
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.simulator-cert-link {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.simulator-cert-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(2px);
}

.simulator-cert-rge-logo {
  width: 1.125rem;
  height: auto;
}

.simulator-cert-icon {
  width: 1rem;
  height: 1rem;
  color: #fbbf24;
}

.simulator-website-link {
  color: #60a5fa;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.simulator-website-link:hover {
  color: #93c5fd;
  transform: translateX(2px);
}

.simulator-footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.25rem;
  border-top: 1px solid #4b5563;
  font-size: 0.875rem;
  color: #9ca3af;
}

.simulator-footer-links {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.simulator-footer-links a {
  color: #9ca3af;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
}

.simulator-footer-links a:hover {
  color: #d1d5db;
}

.simulator-footer-links span {
  cursor: pointer;
  transition: color 0.2s;
}

.simulator-footer-links span:hover:not(:nth-child(even)) {
  color: #d1d5db;
}

/* ===============================================
   LIENS TÉLÉPHONE ET EMAIL
   =============================================== */
.simulator-phone-link,
.simulator-email-link {
  color: inherit;
  text-decoration: none;
  transition: all 0.2s ease;
  border-radius: 4px;
  padding: 0.125rem;
}

.simulator-phone-link:hover,
.simulator-email-link:hover {
  color: var(--color-primary);
  background: rgba(30, 64, 175, 0.1);
  text-decoration: underline;
}

/* ===============================================
   CLASSES UTILITAIRES
   =============================================== */
.simulator-positive {
  color: var(--color-success) !important;
}

.simulator-negative {
  color: var(--color-danger) !important;
}

.simulator-neutral {
  color: var(--color-text-light) !important;
}

.simulator-primary {
  color: var(--color-primary) !important;
}

.simulator-warning {
  color: var(--color-warning) !important;
}

/* ===============================================
   CORRECTIONS SPÉCIFIQUES POUR Z-INDEX ET OVERFLOW
   =============================================== */

/* S'assurer que les parents n'ont pas d'overflow hidden qui masquerait les suggestions */
.simulator-hero-section,
.simulator-hero-content,
.simulator-main-form-container,
.simulator-address-section {
  overflow: visible !important;
}

/* S'assurer que les suggestions sont toujours visibles */
.simulator-address-suggestions {
  /* Forcer le z-index maximum */
  z-index: 999999 !important;
  /* S'assurer que l'élément est dans son propre contexte d'empilement */
  position: absolute !important;
  /* Éviter tout problème de transform qui pourrait créer un nouveau contexte */
  transform: none !important;
  will-change: auto !important;
}

/* Contexte d'empilement pour le conteneur de recherche */
.simulator-address-search-container {
  /* Créer un contexte d'empilement */
  z-index: 1000;
  position: relative;
  /* S'assurer qu'il peut déborder */
  overflow: visible !important;
}

/* ===============================================
   RESPONSIVE DESIGN
   =============================================== */
@media (max-width: 1024px) {
  .simulator-content-layout,
  .simulator-offer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .simulator-right-panel {
    position: relative;
    top: auto;
    order: -1;
  }

  .simulator-savings-hero {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .simulator-header-contact {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-end;
  }

  .simulator-footer-main {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  .simulator-footer-company {
    grid-column: 1 / -1;
    max-width: none;
  }

  .simulator-services-grid-enhanced {
    grid-template-columns: 1fr;
  }

  .simulator-progress-content {
    flex-direction: column;
    gap: 1rem;
  }

  .simulator-sticky-content {
    grid-template-columns: 1fr;
    gap: 1rem;
    text-align: center;
  }

  .simulator-sticky-nav-left {
    order: 2;
    justify-content: flex-start;
  }

  .simulator-sticky-savings {
    order: 1;
  }

  .simulator-sticky-pricing {
    order: 3;
    justify-content: center;
    flex-direction: column;
    gap: 0.75rem;
  }

  .simulator-leasing-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .simulator-battery-types-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .simulator-desktop-only {
    display: none !important;
  }

  .simulator-step-container {
    padding: 1rem;
  }

  .simulator-header-content {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
  }

  .simulator-logo {
    gap: 0.5rem;
  }

  .simulator-logo-text {
    font-size: 1rem;
  }

  .simulator-logo-tagline {
    font-size: 0.7rem;
  }

  .simulator-header-contact {
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
  }

  .simulator-contact-info {
    gap: 0.75rem;
    flex-direction: row;
  }

  .simulator-contact-item {
    font-size: 0.75rem;
  }

  .simulator-progress-bar {
    padding: 0.75rem 0;
  }

  .simulator-progress-content {
    padding: 0 1rem;
    justify-content: center;
  }

  .simulator-progress-navigation {
    flex: 1 1;
  }

  .simulator-progress-steps {
    margin-bottom: 0.5rem;
    gap: 0.5rem;
  }

  .simulator-progress-step {
    width: 2rem;
    height: 2rem;
    font-size: 0.75rem;
  }

  .simulator-progress-line {
    width: 1.5rem;
    margin: 0 0.375rem;
  }

  .simulator-progress-labels {
    gap: 2rem;
    font-size: 0.75rem;
  }

  .simulator-step-1 {
    min-height: 75vh;
    padding: 0;
  }

  .simulator-hero-section {
    min-height: 75vh;
    padding: 1.25rem 0;
  }

  .simulator-hero-content {
    padding: 1.5rem 1.25rem;
    margin: 0 1rem;
    border-radius: 12px;
  }

  .simulator-hero-title {
    font-size: 1.625rem;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  .simulator-hero-subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }

  .simulator-subtitle-features {
    flex-direction: column;
    gap: 0.375rem;
    align-items: center;
  }

  .simulator-feature-pill {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
  }

  .simulator-main-form-container {
    gap: 1.5rem;
  }

  .simulator-address-input-wrapper {
    padding: 0 1rem;
  }

  .simulator-address-input {
    padding: 1rem 0;
    font-size: 0.9rem;
  }

  .simulator-main-cta-button {
    padding: 1rem 1.25rem;
    font-size: 0.9rem;
    gap: 0.375rem;
    min-width: 200px;
  }

  .simulator-address-suggestions {
    border-radius: 8px;
    margin-top: 0.375rem;
    max-height: 240px;
    font-size: 0.875rem;
  }

  .simulator-suggestion-item {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  .simulator-suggestion-label {
    font-size: 0.875rem;
    line-height: 1.2;
  }

  .simulator-suggestion-context {
    font-size: 0.75rem;
  }

  .simulator-success-message {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
    padding: 1rem;
    margin-top: 1.25rem;
  }

  .simulator-trust-indicators {
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1.25rem;
    padding-top: 1.25rem;
  }

  .simulator-price-card {
    position: static;
    margin-bottom: 1.5rem;
    padding: 1.5rem;
    border-radius: 12px;
  }

  .simulator-new-bill-highlight {
    padding: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .simulator-new-bill-amount {
    font-size: 2rem;
  }

  .simulator-pricing-summary {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .simulator-bill-transformation {
    padding: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .simulator-amount-new {
    font-size: 1.5rem;
  }

  .simulator-form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .simulator-form-input {
    padding: 1rem;
    font-size: 0.875rem;
  }

  .simulator-leasing-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .simulator-battery-types-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .simulator-battery-type-card {
    min-height: auto;
  }

  .simulator-sticky-footer {
    background: linear-gradient(135deg, var(--color-primary), #1d4ed8);
  }

  .simulator-sticky-content {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    text-align: center;
    padding: 1rem;
    max-width: 100%;
  }

  .simulator-sticky-nav-left {
    position: absolute;
    top: 0.5rem;
    left: 0.75rem;
    order: unset;
  }

  .simulator-nav-btn.simulator-prev {
    background: rgba(255, 255, 255, 0.15);
    color: white;
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
    border-radius: 6px;
    backdrop-filter: blur(10px);
  }

  .simulator-nav-btn.simulator-prev:hover {
    background: rgba(255, 255, 255, 0.25);
  }

  .simulator-sticky-savings {
    order: 1;
    margin-top: 0.5rem;
  }

  .simulator-sticky-title {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  .simulator-sticky-bills-comparison {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
  }

  .simulator-sticky-amount-old {
    font-size: 1rem;
  }

  .simulator-sticky-amount-new {
    font-size: 1.25rem;
  }

  .simulator-sticky-arrow {
    font-size: 0.875rem;
  }

  .simulator-sticky-pricing {
    order: 2;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-top: 0.75rem;
  }

  .simulator-sticky-price {
    text-align: left;
    flex: 1 1;
  }

  .simulator-sticky-label {
    font-size: 0.75rem;
  }

  .simulator-sticky-amount {
    font-size: 1.125rem;
  }

  .simulator-sticky-cta {
    background: linear-gradient(135deg, var(--color-success), #047857);
    padding: 0.75rem 1.25rem;
    font-size: 0.875rem;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .simulator-sticky-cta:hover:not(:disabled) {
    background: linear-gradient(135deg, #047857, #065f46);
  }

  .simulator-panel-types-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .simulator-panel-type-card {
    padding: 1.25rem;
  }

  .simulator-panel-count-options {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }

  .simulator-panel-count-option {
    padding: 0.875rem 0.5rem;
    margin-top: 0.75rem;
  }

  .simulator-leasing-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .simulator-leasing-card {
    padding: 1.25rem;
    margin-top: 0.75rem;
  }

  .simulator-bill-before-after {
    grid-template-columns: 1fr auto 1fr;
    gap: 0.75rem;
    align-items: center;
  }

  .simulator-transformation-arrow {
    order: 2;
  }

  .simulator-savings-preview-big {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .simulator-preview-item {
    padding: 1rem 0.75rem;
  }

  .simulator-environmental-impact {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
    padding: 1.25rem;
  }

  .simulator-footer-content {
    padding: 2rem 1rem 1rem;
  }

  .simulator-footer-main {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .simulator-footer-company {
    grid-column: auto;
  }

  .simulator-footer-bottom {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .simulator-footer-links {
    flex-wrap: wrap;
    justify-content: center;
  }

  .simulator-bill-section {
    padding: 1.25rem;
  }
}

@media (max-width: 480px) {
  .simulator-hero-content {
    padding: 1.25rem 1rem;
    border-radius: 8px;
  }

  .simulator-hero-title {
    font-size: 1.5rem;
    line-height: 1.1;
    margin-bottom: 0.75rem;
  }

  .simulator-hero-subtitle {
    font-size: 0.875rem;
    margin-bottom: 1.25rem;
  }

  .simulator-address-input-wrapper {
    padding: 0 0.875rem;
  }

  .simulator-address-input {
    padding: 0.875rem 0;
    font-size: 0.875rem;
  }

  .simulator-main-cta-button {
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
    min-width: 180px;
  }

  .simulator-sticky-amount-new {
    font-size: 1.125rem;
  }

  .simulator-sticky-cta {
    padding: 0.75rem 1rem;
    font-size: 0.8rem;
  }

  .simulator-new-bill-mega {
    font-size: 2.25rem;
  }

  .simulator-modal-overlay {
    padding: 1rem;
  }

  .simulator-panel-count-options {
    grid-template-columns: repeat(2, 1fr);
  }

  .simulator-guarantee-badges {
    grid-template-columns: repeat(3, 1fr);
  }

  .simulator-footer-content {
    padding: 1.5rem 0.875rem 0.875rem;
  }

  .simulator-footer-logo-text {
    font-size: 1.125rem;
  }

  .simulator-footer-description {
    font-size: 0.875rem;
  }

  .simulator-footer-contact h4,
  .simulator-footer-certifications h4 {
    font-size: 1rem;
  }

  .simulator-contact-value {
    font-size: 0.875rem;
  }

  .simulator-cert-badge {
    padding: 0.375rem 0.5rem;
    font-size: 0.8rem;
  }

  .simulator-footer-bottom {
    font-size: 0.8rem;
  }

  .simulator-bill-input {
    font-size: 1.5rem;
    width: 6rem;
  }

  .simulator-bill-currency {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SolarSimulator.css"],"names":[],"mappings":"AAAA;;;oDAGoD;;AAEpD;;oDAEoD;AACpD;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;EACpB,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;oDAEoD;AACpD;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uFAAuF;EACvF,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;oDAEoD;AACpD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;oDAEoD;AACpD;EACE,6DAA6D;EAC7D,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;oDAEoD;AACpD;EACE,6DAA6D;EAC7D,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;oDAEoD;AACpD;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;;oDAEoD;AACpD;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB;mFACiF;EACjF,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+EAA+E;EAC/E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;oDAEoD;AACpD;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;oDAEoD;AACpD;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;oDAEoD;AACpD;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,uCAAuC;EACvC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sDAAsD;EACtD,uDAAuD;EACvD,mCAAmC;EACnC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;EACnC,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qDAAqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;EACrD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kEAAkE;EAClE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,cAAc;EACd,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,kEAAkE;EAClE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kCAAkC;EAClC,uFAAuF;EACvF,6CAA6C;AAC/C;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kCAAkC;EAClC,uFAAuF;AACzF;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kEAAkE;EAClE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kEAAkE;EAClE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,SAAO;AACT;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;;oDAEoD;AACpD;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;EACnC,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;oDAEoD;AACpD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;oDAEoD;AACpD;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;oDAEoD;AACpD;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;oDAEoD;AACpD;EACE,qDAAqD;EACrD,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kEAAkE;EAClE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kEAAkE;EAClE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,0CAA0C;EAC1C,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;oDAEoD;AACpD;EACE,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kEAAkE;EAClE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;oDAEoD;AACpD;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,qBAAqB;EACrB,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;oDAEoD;AACpD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;oDAEoD;AACpD;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kEAAkE;EAClE,YAAY;EACZ,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;oDAEoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kEAAkE;EAClE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;oDAEoD;AACpD;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;oDAEoD;AACpD;;EAEE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;oDAEoD;AACpD;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;oDAEoD;;AAEpD,yFAAyF;AACzF;;;;EAIE,4BAA4B;AAC9B;;AAEA,yDAAyD;AACzD;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,sEAAsE;EACtE,6BAA6B;EAC7B,6EAA6E;EAC7E,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,yDAAyD;AACzD;EACE,mCAAmC;EACnC,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;oDAEoD;AACpD;EACE;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kEAAkE;EACpE;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kEAAkE;IAClE,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ===============================================\r\n   SIMULATEUR SOLAIRE AC FLUIDE - CSS COMPLET FINAL\r\n   Correction complète du problème de chevauchement des suggestions\r\n   =============================================== */\r\n\r\n/* ===============================================\r\n   VARIABLES CSS GLOBALES\r\n   =============================================== */\r\n:root {\r\n  --color-primary: #1e40af;\r\n  --color-success: #059669;\r\n  --color-danger: #dc2626;\r\n  --color-warning: #f59e0b;\r\n  --color-text: #1f2937;\r\n  --color-text-light: #64748b;\r\n  --color-background: #ffffff;\r\n  --color-surface: #f8fafc;\r\n  --border-radius: 8px;\r\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.15);\r\n  --z-suggestions: 9999;\r\n  --z-modal: 10000;\r\n  --z-tooltip: 1000;\r\n  --z-sticky: 100;\r\n}\r\n\r\n/* ===============================================\r\n   RESET ET BASE STYLES\r\n   =============================================== */\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.simulator-solar-app {\r\n  min-height: 100vh;\r\n  background: #ffffff;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Inter', sans-serif;\r\n  color: #1f2937;\r\n  overflow-x: hidden;\r\n  line-height: 1.5;\r\n  font-size: 16px;\r\n}\r\n\r\n/* ===============================================\r\n   ANIMATIONS GLOBALES\r\n   =============================================== */\r\n@keyframes simulator-fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes simulator-pulse {\r\n  0%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.03);\r\n  }\r\n}\r\n\r\n@keyframes simulator-spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes simulator-slideInFromBottom {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes simulator-glow {\r\n  0%, 100% {\r\n    box-shadow: 0 0 5px rgba(30, 64, 175, 0.3);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 20px rgba(30, 64, 175, 0.6);\r\n  }\r\n}\r\n\r\n.simulator-spinning {\r\n  animation: simulator-spin 1s linear infinite;\r\n}\r\n\r\n/* ===============================================\r\n   HEADER\r\n   =============================================== */\r\n.simulator-app-header {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-bottom: 1px solid #e2e8f0;\r\n  padding: 0.75rem 0;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: var(--z-sticky);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-header-content {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 0 1.5rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.simulator-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  transition: all 0.2s ease;\r\n  border-radius: var(--border-radius);\r\n  padding: 0.5rem;\r\n}\r\n\r\n.simulator-logo:hover {\r\n  background: rgba(30, 64, 175, 0.05);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.simulator-logo-image {\r\n  width: 6rem;\r\n  height: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.simulator-logo-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.simulator-logo-text {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  color: var(--color-primary);\r\n  line-height: 1;\r\n}\r\n\r\n.simulator-logo-tagline {\r\n  font-size: 0.75rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-header-contact {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.simulator-contact-info {\r\n  display: flex;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.simulator-contact-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-header-contact-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-primary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-expert-btn {\r\n  background: linear-gradient(135deg, var(--color-primary), #1d4ed8);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  box-shadow: 0 1px 3px rgba(30, 64, 175, 0.3);\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.simulator-expert-btn:hover {\r\n  background: linear-gradient(135deg, #1d4ed8, #1e3a8a);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.simulator-btn-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n.simulator-desktop-only {\r\n  display: flex;\r\n}\r\n\r\n/* ===============================================\r\n   PROGRESS BAR\r\n   =============================================== */\r\n.simulator-progress-bar {\r\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\r\n  border-bottom: 1px solid #cbd5e1;\r\n  padding: 1rem 0;\r\n}\r\n\r\n.simulator-progress-content {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 0 1.5rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-progress-navigation {\r\n  flex: 1;\r\n}\r\n\r\n.simulator-progress-steps {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 0.75rem;\r\n  gap: 0;\r\n}\r\n\r\n.simulator-progress-step-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-progress-step {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  background: #e2e8f0;\r\n  color: var(--color-text-light);\r\n  transition: all 0.3s;\r\n  border: 2px solid transparent;\r\n  cursor: pointer;\r\n}\r\n\r\n.simulator-progress-step:disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.simulator-progress-step.simulator-active {\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  color: white;\r\n  border-color: #1d4ed8;\r\n  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.15);\r\n  animation: simulator-pulse 2s infinite;\r\n}\r\n\r\n.simulator-progress-step.simulator-completed {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border-color: var(--color-success);\r\n  cursor: pointer;\r\n}\r\n\r\n.simulator-progress-step.simulator-completed:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.simulator-progress-line {\r\n  width: 2.5rem;\r\n  height: 2px;\r\n  background: #e2e8f0;\r\n  margin: 0 0.75rem;\r\n  transition: all 0.3s;\r\n  border-radius: 2px;\r\n}\r\n\r\n.simulator-progress-line.simulator-active {\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n}\r\n\r\n.simulator-progress-line.simulator-completed {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n}\r\n\r\n.simulator-progress-labels {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 3rem;\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-progress-labels span.simulator-active {\r\n  color: var(--color-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n/* ===============================================\r\n   STRUCTURE PRINCIPALE\r\n   =============================================== */\r\n.simulator-app-main {\r\n  flex: 1;\r\n}\r\n\r\n.simulator-step-container {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 1.5rem;\r\n  animation: simulator-fadeInUp 0.5s ease-out;\r\n}\r\n\r\n/* ===============================================\r\n   ÉTAPE 1 - HERO SECTION RESTRUCTURÉE\r\n   =============================================== */\r\n.simulator-step-1 {\r\n  padding: 0;\r\n  margin: 0;\r\n  min-height: 65vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  max-width: 100%;\r\n}\r\n\r\n.simulator-hero-section {\r\n  width: 100%;\r\n  min-height: 65vh;\r\n  background: linear-gradient(135deg, rgba(30, 64, 175, 0.4), rgba(5, 150, 105, 0.4)), \r\n              url('https://acfluide-simulateur.acfluide.fr/assets/images/fond.jpg');\r\n  background-size: cover;\r\n  background-position: center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem 0;\r\n}\r\n\r\n.simulator-hero-content {\r\n  text-align: center;\r\n  max-width: 650px;\r\n  width: 100%;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  backdrop-filter: blur(10px);\r\n  border-radius: 16px;\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-lg);\r\n  margin: 0 1.5rem;\r\n  animation: simulator-fadeInUp 0.8s ease-out;\r\n  position: relative;\r\n  /* CRUCIAL: ASSURER QUE LE CONTENEUR PEUT DÉBORDER */\r\n  overflow: visible !important;\r\n}\r\n\r\n.simulator-hero-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n  color: #92400e;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 30px;\r\n  font-weight: 700;\r\n  font-size: 0.875rem;\r\n  margin-bottom: 1.5rem;\r\n  border: 1px solid var(--color-warning);\r\n}\r\n\r\n.simulator-badge-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n.simulator-hero-title {\r\n  font-size: 2rem;\r\n  font-weight: 800;\r\n  color: var(--color-text);\r\n  margin-bottom: 1.5rem;\r\n  line-height: 1.1;\r\n}\r\n\r\n.simulator-highlight-text {\r\n  background: linear-gradient(135deg, var(--color-primary), var(--color-success));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.simulator-hero-subtitle {\r\n  font-size: 1.125rem;\r\n  color: var(--color-text);\r\n  margin-bottom: 2rem;\r\n  line-height: 1.4;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-subtitle-features {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  margin-top: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.simulator-feature-pill {\r\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\r\n  color: var(--color-primary);\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n  border: 1px solid var(--color-primary);\r\n}\r\n\r\n/* ===============================================\r\n   CONTENEUR PRINCIPAL DU FORMULAIRE - NOUVELLE STRUCTURE\r\n   =============================================== */\r\n.simulator-main-form-container {\r\n  max-width: 550px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n  /* CRUCIAL: PERMETTRE LE DÉBORDEMENT */\r\n  overflow: visible !important;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n/* ===============================================\r\n   SECTION ADRESSE - RESTRUCTURÉE\r\n   =============================================== */\r\n.simulator-address-section {\r\n  /* CRUCIAL: PERMETTRE LE DÉBORDEMENT */\r\n  overflow: visible !important;\r\n  position: relative;\r\n}\r\n\r\n.simulator-search-instruction {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-instruction-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-primary);\r\n}\r\n\r\n/* CONTENEUR DE RECHERCHE D'ADRESSE */\r\n.simulator-address-search-container {\r\n  position: relative;\r\n  /* CRUCIAL: PERMETTRE LE DÉBORDEMENT POUR LES SUGGESTIONS */\r\n  overflow: visible !important;\r\n  z-index: var(--z-suggestions);\r\n}\r\n\r\n.simulator-address-input-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  box-shadow: var(--shadow-md);\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  padding: 0 1.25rem;\r\n}\r\n\r\n.simulator-address-input-wrapper:focus-within {\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.simulator-search-icon {\r\n  color: #9ca3af;\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  margin-right: 1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-address-input {\r\n  flex: 1;\r\n  border: none;\r\n  padding: 1rem 0;\r\n  font-size: 1rem;\r\n  outline: none;\r\n  font-weight: 500;\r\n  color: var(--color-text);\r\n  background: transparent;\r\n}\r\n\r\n.simulator-address-input::placeholder {\r\n  color: #9ca3af;\r\n  font-weight: 400;\r\n}\r\n\r\n.simulator-loading-indicator {\r\n  position: absolute;\r\n  right: 1rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #6b7280;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* ===============================================\r\n   SUGGESTIONS D'ADRESSE - POSITION CORRIGÉE\r\n   =============================================== */\r\n.simulator-address-suggestions {\r\n  position: absolute !important;\r\n  top: 100% !important;\r\n  left: 0 !important;\r\n  right: 0 !important;\r\n  background: white !important;\r\n  border: 2px solid #d1d5db !important;\r\n  border-radius: 8px !important;\r\n  margin-top: 0.25rem !important;\r\n  box-shadow: var(--shadow-lg) !important;\r\n  z-index: 999999 !important;\r\n  max-height: 280px !important;\r\n  overflow-y: auto !important;\r\n  animation: simulator-fadeInUp 0.2s ease-out !important;\r\n  /* ASSURER QUE LES SUGGESTIONS SONT AU-DESSUS DE TOUT */\r\n  transform: translateZ(0) !important;\r\n  /* Forcer l'affichage au-dessus */\r\n  will-change: auto !important;\r\n}\r\n\r\n.simulator-suggestion-item {\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: white;\r\n  position: relative;\r\n}\r\n\r\n.simulator-suggestion-item:hover {\r\n  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);\r\n  border-left: 3px solid var(--color-primary);\r\n  transform: translateX(2px);\r\n}\r\n\r\n.simulator-suggestion-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.simulator-suggestion-content {\r\n  flex: 1;\r\n  text-align: left;\r\n  padding-right: 0.75rem;\r\n}\r\n\r\n.simulator-suggestion-label {\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.25rem;\r\n  font-size: 0.9rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.simulator-suggestion-context {\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n}\r\n\r\n.simulator-suggestion-arrow {\r\n  color: var(--color-primary);\r\n  font-weight: bold;\r\n  font-size: 1rem;\r\n  opacity: 0;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-suggestion-item:hover .simulator-suggestion-arrow {\r\n  opacity: 1;\r\n  transform: translateX(2px);\r\n}\r\n\r\n/* ===============================================\r\n   SECTION FACTURE ÉLECTRIQUE\r\n   =============================================== */\r\n.simulator-bill-section {\r\n  background: white;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  border: 2px solid #e2e8f0;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-bill-input-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.simulator-bill-input {\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  background: var(--color-surface);\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: var(--border-radius);\r\n  padding: 0.5rem 0.75rem;\r\n  width: 7rem;\r\n  outline: none;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.simulator-bill-input:focus {\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);\r\n}\r\n\r\n.simulator-bill-currency {\r\n  font-size: 1.5rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 600;\r\n}\r\n\r\n/* Range slider */\r\n.simulator-range-slider {\r\n  width: 100%;\r\n  height: 6px;\r\n  background: #e2e8f0;\r\n  border-radius: 3px;\r\n  outline: none;\r\n  -webkit-appearance: none;\r\n  cursor: pointer;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.simulator-range-slider::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n\r\n.simulator-range-labels {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-consumption-stats {\r\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.simulator-stat-item {\r\n  text-align: center;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 6px;\r\n}\r\n\r\n.simulator-stat-item span {\r\n  display: block;\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-stat-item strong {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: var(--color-primary);\r\n}\r\n\r\n/* ===============================================\r\n   SECTION CTA\r\n   =============================================== */\r\n.simulator-cta-section {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-main-cta-button {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border: none;\r\n  padding: 1rem 1.5rem;\r\n  border-radius: 12px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\r\n  min-width: 250px;\r\n}\r\n\r\n.simulator-main-cta-button:hover:not(:disabled) {\r\n  background: linear-gradient(135deg, #047857, #065f46);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);\r\n}\r\n\r\n.simulator-main-cta-button:disabled {\r\n  background: #9ca3af;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.simulator-btn-text {\r\n  font-weight: 700;\r\n}\r\n\r\n.simulator-btn-icon {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* ===============================================\r\n   MESSAGES DE SUCCÈS\r\n   =============================================== */\r\n.simulator-success-message {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  background: linear-gradient(135deg, #d1fae5, #a7f3d0);\r\n  color: #065f46;\r\n  padding: 1.25rem;\r\n  border-radius: 10px;\r\n  margin-top: 2rem;\r\n  border: 1px solid #10b981;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  animation: simulator-slideInFromBottom 0.5s ease-out;\r\n}\r\n\r\n.simulator-success-icon-wrapper {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  background: #10b981;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-success-icon {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  color: white;\r\n}\r\n\r\n.simulator-success-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.simulator-success-title {\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-success-text {\r\n  font-weight: 500;\r\n  opacity: 0.9;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* ===============================================\r\n   INDICATEURS DE CONFIANCE\r\n   =============================================== */\r\n.simulator-trust-indicators {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1.5rem;\r\n  margin-top: 1.5rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-trust-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-weight: 600;\r\n  color: var(--color-text-light);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-trust-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-weight: 600;\r\n  color: var(--color-text-light);\r\n  font-size: 0.875rem;\r\n  text-decoration: none;\r\n  transition: all 0.2s ease;\r\n  padding: 0.5rem;\r\n  border-radius: var(--border-radius);\r\n}\r\n\r\n.simulator-trust-link:hover {\r\n  background: rgba(30, 64, 175, 0.1);\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-rge-logo {\r\n  width: 1.5rem;\r\n  height: auto;\r\n}\r\n\r\n.simulator-trust-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-warning);\r\n}\r\n\r\n/* ===============================================\r\n   ÉTAPE 2 - LAYOUT DE CONFIGURATION\r\n   =============================================== */\r\n.simulator-content-layout {\r\n  display: grid;\r\n  grid-template-columns: 1fr 360px;\r\n  gap: 2.5rem;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.simulator-left-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n.simulator-right-panel {\r\n  position: sticky;\r\n  top: 120px;\r\n  height: fit-content;\r\n}\r\n\r\n.simulator-section-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.simulator-section-title {\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-section-subtitle {\r\n  font-size: 1rem;\r\n  color: var(--color-text-light);\r\n  line-height: 1.4;\r\n  max-width: 450px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ===============================================\r\n   TOOLTIPS\r\n   =============================================== */\r\n.simulator-tooltip-wrapper {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.simulator-tooltip-trigger {\r\n  background: none;\r\n  border: none;\r\n  color: var(--color-primary);\r\n  cursor: pointer;\r\n  padding: 0.25rem;\r\n  border-radius: 50%;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-tooltip-trigger:hover {\r\n  background: rgba(30, 64, 175, 0.1);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.simulator-tooltip-content {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  box-shadow: var(--shadow-lg);\r\n  z-index: var(--z-tooltip);\r\n  width: 280px;\r\n  margin-top: 0.5rem;\r\n  animation: simulator-fadeInUp 0.2s ease-out;\r\n}\r\n\r\n.simulator-tooltip-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-tooltip-header h4 {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  margin: 0;\r\n}\r\n\r\n.simulator-tooltip-close {\r\n  background: none;\r\n  border: none;\r\n  color: var(--color-text-light);\r\n  cursor: pointer;\r\n  padding: 0.25rem;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.simulator-tooltip-close:hover {\r\n  background: #f3f4f6;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-tooltip-content p {\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  line-height: 1.4;\r\n  margin: 0;\r\n}\r\n\r\n.simulator-tooltip-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 999;\r\n}\r\n\r\n/* ===============================================\r\n   SECTIONS DE CONFIGURATION\r\n   =============================================== */\r\n.simulator-config-section {\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-config-section h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  margin-bottom: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n/* ===============================================\r\n   TYPES DE PANNEAUX\r\n   =============================================== */\r\n.simulator-panel-types-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-panel-type-card {\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  text-align: center;\r\n  background: white;\r\n  position: relative;\r\n  box-shadow: var(--shadow-sm);\r\n  overflow: hidden;\r\n}\r\n\r\n.simulator-panel-type-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: linear-gradient(135deg, #e2e8f0, #cbd5e1);\r\n  transition: all 0.3s;\r\n}\r\n\r\n.simulator-panel-type-card:hover {\r\n  border-color: var(--color-primary);\r\n  transform: translateY(-4px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.simulator-panel-type-card:hover::before {\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n}\r\n\r\n.simulator-panel-type-card.simulator-selected {\r\n  border-color: var(--color-success);\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.simulator-panel-type-card.simulator-selected::before {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n}\r\n\r\n.simulator-panel-recommendation {\r\n  position: absolute;\r\n  top: 1rem;\r\n  left: 1rem;\r\n  background: linear-gradient(135deg, var(--color-warning), #d97706);\r\n  color: white;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 15px;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.simulator-panel-badge {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1rem;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  background: linear-gradient(135deg, #f1f5f9, #e2e8f0);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1rem;\r\n  border: 2px solid white;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-panel-type-name {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin: 2rem 0 0.75rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-panel-type-description {\r\n  font-size: 0.9rem;\r\n  color: var(--color-text-light);\r\n  line-height: 1.3;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-panel-specs {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-spec-item {\r\n  background: rgba(248, 250, 252, 0.8);\r\n  padding: 0.75rem 0.5rem;\r\n  border-radius: var(--border-radius);\r\n  text-align: center;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-spec-item span {\r\n  display: block;\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n  margin-bottom: 0.25rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-spec-item strong {\r\n  color: var(--color-text);\r\n  font-weight: 700;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* ===============================================\r\n   OPTIONS DE NOMBRE DE PANNEAUX\r\n   =============================================== */\r\n.simulator-panel-count-options {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-panel-count-option {\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 1.25rem 0.5rem;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  background: white;\r\n  position: relative;\r\n  margin-top: 1rem;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-panel-count-option:hover {\r\n  border-color: var(--color-primary);\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.simulator-panel-count-option.simulator-selected {\r\n  border-color: var(--color-success);\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.15);\r\n}\r\n\r\n.simulator-panel-count-number {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.9rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.simulator-panel-count-power {\r\n  font-size: 1rem;\r\n  color: var(--color-primary);\r\n  font-weight: 700;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.simulator-panel-count-production {\r\n  font-size: 0.75rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-popular-badge {\r\n  position: absolute;\r\n  top: -0.75rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: linear-gradient(135deg, var(--color-warning), #d97706);\r\n  color: white;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 20px;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  z-index: 10;\r\n}\r\n\r\n/* ===============================================\r\n   SECTION BATTERIES\r\n   =============================================== */\r\n.simulator-battery-subtitle {\r\n  font-size: 0.9rem;\r\n  color: var(--color-text-light);\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.simulator-battery-types-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-battery-type-card {\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 1.25rem;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  background: white;\r\n  position: relative;\r\n  box-shadow: var(--shadow-sm);\r\n  overflow: hidden;\r\n  min-height: 380px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.simulator-battery-type-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: #e2e8f0;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.simulator-battery-type-card:hover {\r\n  border-color: var(--color-primary);\r\n  transform: translateY(-3px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.simulator-battery-type-card:hover::before {\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n}\r\n\r\n.simulator-battery-type-card.simulator-selected {\r\n  border-color: var(--color-success);\r\n  background: linear-gradient(135deg, rgba(236, 253, 245, 0.8), rgba(209, 250, 229, 0.8));\r\n  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);\r\n}\r\n\r\n.simulator-battery-type-card.simulator-selected::before {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n}\r\n\r\n.simulator-battery-type-card.simulator-recommended {\r\n  border-color: var(--color-warning);\r\n  background: linear-gradient(135deg, rgba(254, 243, 199, 0.6), rgba(253, 230, 138, 0.6));\r\n}\r\n\r\n.simulator-battery-type-card.simulator-recommended::before {\r\n  background: linear-gradient(135deg, var(--color-warning), #d97706);\r\n}\r\n\r\n.simulator-recommendation-badge {\r\n  position: absolute;\r\n  top: 0.75rem;\r\n  right: 0.75rem;\r\n  background: linear-gradient(135deg, var(--color-warning), #d97706);\r\n  color: white;\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 15px;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-battery-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-battery-icon {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  flex-shrink: 0;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-battery-info h4 {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.375rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-battery-info p {\r\n  color: var(--color-text-light);\r\n  font-size: 0.825rem;\r\n  line-height: 1.3;\r\n  margin: 0;\r\n}\r\n\r\n.simulator-battery-stats {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-battery-stat {\r\n  background: rgba(248, 250, 252, 0.8);\r\n  padding: 0.625rem;\r\n  border-radius: var(--border-radius);\r\n  text-align: center;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-battery-stat span {\r\n  display: block;\r\n  font-size: 0.75rem;\r\n  color: var(--color-text-light);\r\n  margin-bottom: 0.375rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-battery-stat strong {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-autoconso-rate {\r\n  color: var(--color-success) !important;\r\n}\r\n\r\n.simulator-battery-details {\r\n  margin-bottom: 0.75rem;\r\n  flex: 1;\r\n}\r\n\r\n.simulator-advantages,\r\n.simulator-disadvantages {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-advantages h5,\r\n.simulator-disadvantages h5 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.375rem;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.375rem;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-advantages h5 {\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-disadvantages h5 {\r\n  color: #dc2626;\r\n}\r\n\r\n.simulator-advantages ul,\r\n.simulator-disadvantages ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.simulator-advantages li,\r\n.simulator-disadvantages li {\r\n  font-size: 0.75rem;\r\n  color: var(--color-text-light);\r\n  margin-bottom: 0.2rem;\r\n  padding-left: 1rem;\r\n  position: relative;\r\n  line-height: 1.2;\r\n}\r\n\r\n.simulator-advantages li::before {\r\n  content: '✓';\r\n  position: absolute;\r\n  left: 0;\r\n  color: var(--color-success);\r\n  font-weight: bold;\r\n}\r\n\r\n.simulator-disadvantages li::before {\r\n  content: '⚠';\r\n  position: absolute;\r\n  left: 0;\r\n  color: #dc2626;\r\n  font-weight: bold;\r\n}\r\n\r\n.simulator-battery-learn-more {\r\n  background: #eff6ff;\r\n  border: 1px solid var(--color-primary);\r\n  color: var(--color-primary);\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.375rem;\r\n  width: 100%;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-battery-learn-more:hover {\r\n  background: var(--color-primary);\r\n  color: white;\r\n}\r\n\r\n/* ===============================================\r\n   CONFIGURATION BATTERIE PHYSIQUE\r\n   =============================================== */\r\n.simulator-battery-config {\r\n  border-top: 1px solid #d1fae5;\r\n  padding-top: 1.25rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.simulator-power-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-power-header label {\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-power-value {\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-battery-benefit {\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n  color: #92400e;\r\n  padding: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  margin-top: 0.75rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* ===============================================\r\n   APERÇU ÉCONOMIES\r\n   =============================================== */\r\n.simulator-economy-preview {\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.simulator-economy-comparison {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  gap: 1rem;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-economy-before,\r\n.simulator-economy-after {\r\n  text-align: center;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n}\r\n\r\n.simulator-economy-before {\r\n  background: linear-gradient(135deg, #fef2f2, #fee2e2);\r\n  border: 1px solid var(--color-danger);\r\n}\r\n\r\n.simulator-economy-after {\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n  border: 1px solid var(--color-success);\r\n}\r\n\r\n.simulator-economy-before span,\r\n.simulator-economy-after span {\r\n  display: block;\r\n  font-size: 0.8rem;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-amount {\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.simulator-amount.current {\r\n  color: var(--color-danger);\r\n}\r\n\r\n.simulator-amount.savings {\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-economy-arrow {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.simulator-arrow-icon {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-economy-arrow span {\r\n  font-size: 0.75rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-savings-badge {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n/* ===============================================\r\n   CALCUL PVGIS - LOADING AMÉLIORÉ\r\n   =============================================== */\r\n.simulator-pvgis-loading-enhanced {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2.5rem 1.5rem;\r\n  text-align: center;\r\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\r\n  border-radius: 12px;\r\n  border: 2px solid #e2e8f0;\r\n}\r\n\r\n.simulator-pvgis-animation {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n  width: 100%;\r\n  max-width: 400px;\r\n}\r\n\r\n.simulator-calculation-steps {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.simulator-calculation-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: var(--border-radius);\r\n  background: rgba(248, 250, 252, 0.8);\r\n  border: 1px solid #e2e8f0;\r\n  transition: all 0.3s ease;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-calculation-step.simulator-completed {\r\n  background: rgba(5, 150, 105, 0.1);\r\n  border: 1px solid var(--color-success);\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-calculation-step.simulator-active {\r\n  background: rgba(30, 64, 175, 0.1);\r\n  border: 1px solid var(--color-primary);\r\n  animation: simulator-glow 1.5s infinite;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-calculation-step.simulator-pending {\r\n  background: rgba(148, 163, 184, 0.1);\r\n  border: 1px solid #94a3b8;\r\n  color: #64748b;\r\n}\r\n\r\n.simulator-step-icon {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-calculation-step.simulator-completed .simulator-step-icon {\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-calculation-step.simulator-active .simulator-step-icon {\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-calculation-step.simulator-pending .simulator-step-icon {\r\n  color: #94a3b8;\r\n}\r\n\r\n.simulator-calculation-description {\r\n  text-align: center;\r\n}\r\n\r\n.simulator-calculation-description h4 {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: var(--color-primary);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-calculation-description p {\r\n  font-size: 0.9rem;\r\n  color: var(--color-text-light);\r\n  margin: 0;\r\n}\r\n\r\n/* ===============================================\r\n   SECTION LOA\r\n   =============================================== */\r\n.simulator-leasing-subtitle {\r\n  font-size: 0.9rem;\r\n  color: var(--color-text-light);\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-leasing-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-leasing-card {\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  box-shadow: var(--shadow-sm);\r\n  margin-top: 1rem;\r\n}\r\n\r\n.simulator-leasing-card:hover {\r\n  border-color: var(--color-primary);\r\n  transform: translateY(-3px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.simulator-leasing-card.simulator-selected {\r\n  border-color: var(--color-success);\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);\r\n}\r\n\r\n.simulator-leasing-card.simulator-popular {\r\n  border-color: var(--color-warning);\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n}\r\n\r\n.simulator-leasing-duration {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: center;\r\n  gap: 0.25rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-years {\r\n  font-size: 2rem;\r\n  font-weight: 800;\r\n  color: var(--color-text);\r\n  line-height: 1;\r\n}\r\n\r\n.simulator-years-label {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--color-text-light);\r\n}\r\n\r\n.simulator-leasing-details {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-monthly-amount {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: center;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.simulator-amount-value {\r\n  font-size: 1.25rem;\r\n  font-weight: 800;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-amount-label {\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n/* ===============================================\r\n   OPTIONS ET TOGGLES\r\n   =============================================== */\r\n.simulator-option-card {\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1rem;\r\n  transition: all 0.2s;\r\n  background: white;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.simulator-option-card.simulator-active {\r\n  border-color: var(--color-success);\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n}\r\n\r\n.simulator-option-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-option-info {\r\n  display: flex;\r\n  gap: 1rem;\r\n  flex: 1;\r\n}\r\n\r\n.simulator-option-icon {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  color: var(--color-primary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-option-info h4 {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-option-info p {\r\n  color: var(--color-text-light);\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-info-link {\r\n  background: none;\r\n  border: none;\r\n  color: var(--color-primary);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Toggle Switch */\r\n.simulator-toggle {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 3rem;\r\n  height: 1.5rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-toggle input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.simulator-toggle-slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #e2e8f0;\r\n  transition: 0.3s;\r\n  border-radius: 8px;\r\n}\r\n\r\n.simulator-toggle-slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n  left: 0.125rem;\r\n  bottom: 0.125rem;\r\n  background-color: white;\r\n  transition: 0.3s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.simulator-toggle input:checked + .simulator-toggle-slider {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n}\r\n\r\n.simulator-toggle input:checked + .simulator-toggle-slider:before {\r\n  transform: translateX(1.5rem);\r\n}\r\n\r\n.simulator-charging-benefit {\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n  color: #92400e;\r\n  padding: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  margin-top: 0.75rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-option-price {\r\n  text-align: center;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.simulator-price-details {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: var(--color-surface);\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-price-details strong {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: var(--color-success);\r\n}\r\n\r\n/* ===============================================\r\n   SERVICES INCLUS\r\n   =============================================== */\r\n.simulator-services-section {\r\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  margin: 2rem 0;\r\n}\r\n\r\n.simulator-services-section h3 {\r\n  font-size: 1.375rem;\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-services-grid {\r\n  display: grid;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.simulator-service-card {\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  display: flex;\r\n  gap: 1rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.simulator-service-card:hover {\r\n  border-color: var(--color-primary);\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.simulator-service-icon {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-service-content {\r\n  flex: 1;\r\n}\r\n\r\n.simulator-service-content h4 {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-service-content p {\r\n  color: var(--color-text-light);\r\n  line-height: 1.4;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-service-content ul {\r\n  margin: 0.5rem 0 1rem 1rem;\r\n  color: var(--color-text-light);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-service-content li {\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.simulator-service-included {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(5, 150, 105, 0.1);\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  color: #065f46;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-service-benefit {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(30, 64, 175, 0.1);\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  color: var(--color-primary);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-check-icon,\r\n.simulator-benefit-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n/* ===============================================\r\n   SECTIONS INFO ET CTA\r\n   =============================================== */\r\n.simulator-info-section {\r\n  margin: 2rem 0;\r\n}\r\n\r\n.simulator-info-card {\r\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\r\n  border: 2px solid var(--color-primary);\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  display: flex;\r\n  gap: 1rem;\r\n  align-items: flex-start;\r\n}\r\n\r\n.simulator-info-icon {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  color: var(--color-primary);\r\n  flex-shrink: 0;\r\n  margin-top: 0.125rem;\r\n}\r\n\r\n.simulator-info-content h4 {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-info-content p {\r\n  color: var(--color-text-light);\r\n  line-height: 1.4;\r\n  font-size: 0.9rem;\r\n  margin: 0;\r\n}\r\n\r\n.simulator-cta-section {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-cta-card {\r\n  background: linear-gradient(135deg, #f8fafc, #f1f5f9);\r\n  border: 2px solid var(--color-primary);\r\n  border-radius: 16px;\r\n  padding: 2rem;\r\n  max-width: 600px;\r\n  width: 100%;\r\n  text-align: center;\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.simulator-cta-content h3 {\r\n  font-size: 1.5rem;\r\n  font-weight: 800;\r\n  color: var(--color-text);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-cta-content p {\r\n  font-size: 1.125rem;\r\n  color: var(--color-text-light);\r\n  margin-bottom: 1.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-cta-benefits {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  margin-bottom: 2rem;\r\n  align-items: flex-start;\r\n  max-width: 400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.simulator-cta-benefit {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-cta-check {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  color: var(--color-success);\r\n  background: rgba(5, 150, 105, 0.1);\r\n  border-radius: 50%;\r\n  padding: 0.125rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-main-cta-btn {\r\n  background: linear-gradient(135deg, var(--color-primary), #1d4ed8);\r\n  color: white;\r\n  border: none;\r\n  padding: 1rem 2rem;\r\n  border-radius: 12px;\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);\r\n  margin: 0 auto;\r\n}\r\n\r\n.simulator-main-cta-btn:hover {\r\n  background: linear-gradient(135deg, #1d4ed8, #1e3a8a);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.4);\r\n}\r\n\r\n.simulator-cta-arrow {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.simulator-main-cta-btn:hover .simulator-cta-arrow {\r\n  transform: translateX(2px);\r\n}\r\n\r\n/* ===============================================\r\n   PANNEAU DROIT - RÉCAPITULATIF\r\n   =============================================== */\r\n.simulator-view-mode-switch {\r\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\r\n  border: 2px solid var(--color-primary);\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-switch-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-switch-label {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--color-text-light);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.simulator-switch-label.active {\r\n  color: var(--color-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.simulator-toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 3rem;\r\n  height: 1.5rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-toggle-switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.simulator-switch-slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #e2e8f0;\r\n  transition: 0.3s;\r\n  border-radius: 12px;\r\n}\r\n\r\n.simulator-switch-slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 1.125rem;\r\n  width: 1.125rem;\r\n  left: 0.1875rem;\r\n  bottom: 0.1875rem;\r\n  background-color: white;\r\n  transition: 0.3s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.simulator-toggle-switch input:checked + .simulator-switch-slider {\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n}\r\n\r\n.simulator-toggle-switch input:checked + .simulator-switch-slider:before {\r\n  transform: translateX(1.5rem);\r\n}\r\n\r\n.simulator-price-card {\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.simulator-price-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1.5rem;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-sparkle-icon {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  color: var(--color-warning);\r\n}\r\n\r\n.simulator-price-header span {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-new-bill-highlight {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-highlight-label {\r\n  font-size: 0.9rem;\r\n  opacity: 0.9;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-new-bill-amount {\r\n  font-size: 2.25rem;\r\n  font-weight: 800;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-old-bill-crossed {\r\n  font-size: 0.9rem;\r\n  opacity: 0.8;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-old-bill-crossed span {\r\n  text-decoration: line-through;\r\n  opacity: 0.7;\r\n}\r\n\r\n.simulator-economy-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-economy-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n.simulator-bill-disclaimer {\r\n  font-size: 0.75rem;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  text-align: center;\r\n  margin-top: 0.5rem;\r\n  font-style: italic;\r\n}\r\n\r\n.simulator-price-breakdown {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-price-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.75rem 0;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.simulator-price-item span {\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-price-item strong {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-savings-text {\r\n  color: var(--color-success) !important;\r\n}\r\n\r\n.simulator-price-total {\r\n  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius);\r\n  margin-top: 0.75rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-net-impact {\r\n  font-size: 1.25rem;\r\n  font-weight: 800;\r\n}\r\n\r\n.simulator-net-impact.positive {\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-net-impact.negative {\r\n  color: var(--color-danger);\r\n}\r\n\r\n.simulator-leasing-selected {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: #eff6ff;\r\n  padding: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-clock-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-leasing-selected span {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-benefits-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.simulator-benefit-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-weight: 500;\r\n  color: var(--color-text);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-check-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-long-term-savings {\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n  border: 2px solid var(--color-warning);\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  margin: 1.5rem 0;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-long-term-savings h4 {\r\n  font-weight: 700;\r\n  color: #92400e;\r\n  margin-bottom: 0.75rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-savings-value {\r\n  font-size: 1.75rem;\r\n  font-weight: 800;\r\n  color: #92400e;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-long-term-savings p {\r\n  font-size: 0.8rem;\r\n  color: #92400e;\r\n  opacity: 0.8;\r\n  margin: 0;\r\n}\r\n\r\n.simulator-production-highlight {\r\n  margin: 1.5rem 0;\r\n}\r\n\r\n.simulator-production-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.25rem;\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  color: white;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.simulator-production-icon {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-production-details {\r\n  flex: 1;\r\n}\r\n\r\n.simulator-production-title {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.simulator-production-value {\r\n  font-size: 1.75rem;\r\n  font-weight: 800;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-production-subtitle {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  opacity: 0.95;\r\n}\r\n\r\n.simulator-right-panel-cta {\r\n  margin-top: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-devis-cta-btn {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.875rem 1.5rem;\r\n  border-radius: 10px;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);\r\n}\r\n\r\n.simulator-devis-cta-btn:hover {\r\n  background: linear-gradient(135deg, #047857, #065f46);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);\r\n}\r\n\r\n.simulator-cta-disclaimer {\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n  margin-top: 0.5rem;\r\n  font-style: italic;\r\n}\r\n\r\n.simulator-price-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2.5rem 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-price-loading .simulator-loading-spinner {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border: 2px solid rgba(30, 64, 175, 0.3);\r\n  border-top: 2px solid var(--color-primary);\r\n  border-radius: 50%;\r\n  animation: simulator-spin 1s linear infinite;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-price-loading p {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--color-primary);\r\n  margin: 0 0 0.5rem 0;\r\n}\r\n\r\n.simulator-price-loading span {\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n/* ===============================================\r\n   SERVICE DETAILS BUTTON\r\n   =============================================== */\r\n.simulator-service-details-btn {\r\n  background: #eff6ff;\r\n  border: 1px solid var(--color-primary);\r\n  color: var(--color-primary);\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.375rem;\r\n}\r\n\r\n.simulator-service-details-btn:hover {\r\n  background: var(--color-primary);\r\n  color: white;\r\n}\r\n\r\n/* ===============================================\r\n   ÉTAPE 3 - FORMULAIRE DE CONTACT\r\n   =============================================== */\r\n.simulator-contact-hero {\r\n  text-align: center;\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.simulator-contact-icon {\r\n  width: 3.5rem;\r\n  height: 3.5rem;\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 1rem;\r\n  color: white;\r\n}\r\n\r\n.simulator-contact-title {\r\n  font-size: 1.75rem;\r\n  font-weight: 800;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-contact-subtitle {\r\n  font-size: 1.125rem;\r\n  color: var(--color-text-light);\r\n  line-height: 1.4;\r\n}\r\n\r\n.simulator-savings-preview-big {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 1.25rem;\r\n  margin: 2rem 0;\r\n  max-width: 550px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.simulator-preview-item {\r\n  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: var(--border-radius);\r\n  padding: 1.25rem 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-preview-item span {\r\n  display: block;\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-preview-item strong {\r\n  font-size: 1.375rem;\r\n  font-weight: 800;\r\n}\r\n\r\n.simulator-preview-item strong.simulator-positive {\r\n  color: var(--color-success);\r\n}\r\n\r\n.simulator-contact-form {\r\n  max-width: 550px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.simulator-form-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1.25rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.simulator-form-group {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.simulator-form-label {\r\n  display: block;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-form-input {\r\n  width: 100%;\r\n  padding: 0.875rem;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: var(--border-radius);\r\n  font-size: 0.9rem;\r\n  outline: none;\r\n  transition: all 0.2s;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-form-input:focus {\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);\r\n}\r\n\r\n.simulator-input-with-icon {\r\n  position: relative;\r\n}\r\n\r\n.simulator-input-icon {\r\n  position: absolute;\r\n  left: 0.875rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 1.125rem;\r\n  height: 1.125rem;\r\n  color: #9ca3af;\r\n}\r\n\r\n.simulator-input-with-icon-field {\r\n  padding-left: 2.5rem;\r\n}\r\n\r\n.simulator-input-with-prefix {\r\n  display: flex;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: var(--border-radius);\r\n  overflow: hidden;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.simulator-input-with-prefix:focus-within {\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);\r\n}\r\n\r\n.simulator-phone-prefix {\r\n  background: var(--color-surface);\r\n  padding: 0.875rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 600;\r\n  border-right: 1px solid #e2e8f0;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-phone-input {\r\n  border: none;\r\n  flex: 1;\r\n  padding: 0.875rem;\r\n  font-size: 0.9rem;\r\n  outline: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-consent-box {\r\n  background: linear-gradient(135deg, #dbeafe, #bfdbfe);\r\n  border-radius: var(--border-radius);\r\n  padding: 1.25rem;\r\n  margin: 1.25rem 0;\r\n  border: 1px solid var(--color-primary);\r\n}\r\n\r\n.simulator-consent-label {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  cursor: pointer;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-consent-checkbox {\r\n  margin-top: 0.125rem;\r\n  width: 1.125rem;\r\n  height: 1.125rem;\r\n  accent-color: var(--color-primary);\r\n}\r\n\r\n.simulator-consent-label span {\r\n  font-size: 0.875rem;\r\n  line-height: 1.4;\r\n  color: var(--color-primary);\r\n}\r\n\r\n/* ===============================================\r\n   TIMELINE\r\n   =============================================== */\r\n.simulator-timeline {\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n  border-radius: 10px;\r\n  padding: 2rem;\r\n  margin-top: 2rem;\r\n  border: 2px solid var(--color-warning);\r\n}\r\n\r\n.simulator-timeline-title {\r\n  font-weight: 700;\r\n  color: #92400e;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.25rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-timeline-steps {\r\n  display: grid;\r\n  gap: 1.25rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-timeline-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-timeline-step.simulator-done .simulator-timeline-icon {\r\n  background: var(--color-success);\r\n}\r\n\r\n.simulator-timeline-step.simulator-next .simulator-timeline-icon {\r\n  background: var(--color-primary);\r\n  animation: simulator-pulse 2s infinite;\r\n}\r\n\r\n.simulator-timeline-step.simulator-future .simulator-timeline-icon {\r\n  background: #94a3b8;\r\n}\r\n\r\n.simulator-timeline-icon {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  background: var(--color-warning);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  position: relative;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-status-check {\r\n  position: absolute;\r\n  top: -0.25rem;\r\n  right: -0.25rem;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  background: var(--color-success);\r\n  border-radius: 50%;\r\n  border: 2px solid white;\r\n}\r\n\r\n.simulator-timeline-content {\r\n  flex: 1;\r\n}\r\n\r\n.simulator-timeline-step-title {\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.25rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-timeline-step-time {\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-contact-support {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  border: 1px solid rgba(146, 64, 14, 0.2);\r\n}\r\n\r\n.simulator-support-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-support-icon {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-support-header h5 {\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  font-size: 1rem;\r\n  margin: 0;\r\n}\r\n\r\n.simulator-support-contacts {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-support-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  background: var(--color-surface);\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius);\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-support-item-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-primary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-support-item div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.simulator-support-label {\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-support-value {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-support-hours {\r\n  text-align: center;\r\n  font-size: 0.875rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* ===============================================\r\n   ÉTAPE 4 - OFFRE FINALE\r\n   =============================================== */\r\n.simulator-offer-hero {\r\n  text-align: center;\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.simulator-offer-icon {\r\n  width: 3.5rem;\r\n  height: 3.5rem;\r\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0 auto 1rem;\r\n  color: white;\r\n}\r\n\r\n.simulator-offer-title {\r\n  font-size: 2rem;\r\n  font-weight: 800;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-offer-subtitle {\r\n  font-size: 1.125rem;\r\n  color: var(--color-text-light);\r\n}\r\n\r\n.simulator-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3.5rem 0;\r\n  gap: 1.25rem;\r\n}\r\n\r\n.simulator-loading-spinner {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  border: 3px solid #e2e8f0;\r\n  border-top: 3px solid var(--color-primary);\r\n  border-radius: 50%;\r\n  animation: simulator-spin 1s linear infinite;\r\n}\r\n\r\n.simulator-loading p {\r\n  font-size: 1rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-offer-content {\r\n  display: grid;\r\n  grid-template-columns: 1fr 380px;\r\n  gap: 2.5rem;\r\n}\r\n\r\n.simulator-main-savings-highlight {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border-radius: 10px;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-main-savings-highlight h3 {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 1.25rem;\r\n  opacity: 0.95;\r\n}\r\n\r\n.simulator-savings-hero {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 2rem;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-savings-main span {\r\n  display: block;\r\n  font-size: 1rem;\r\n  opacity: 0.9;\r\n  margin-bottom: 0.75rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-new-bill-mega {\r\n  font-size: 2.75rem;\r\n  font-weight: 800;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-old-bill-mega {\r\n  font-size: 1.125rem;\r\n  opacity: 0.8;\r\n  text-decoration: line-through;\r\n}\r\n\r\n.simulator-bill-disclaimer-main {\r\n  font-size: 0.75rem;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.simulator-savings-details {\r\n  display: grid;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-saving-detail {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-saving-detail span {\r\n  opacity: 0.9;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-saving-detail strong {\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-saving-detail strong.simulator-positive {\r\n  color: #a7f3d0;\r\n}\r\n\r\n.simulator-installation-summary {\r\n  background: linear-gradient(135deg, var(--color-primary), #7c3aed);\r\n  border-radius: 10px;\r\n  padding: 2rem;\r\n  color: white;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.simulator-installation-summary .simulator-section-title {\r\n  color: white;\r\n  text-align: left;\r\n}\r\n\r\n.simulator-summary-grid {\r\n  display: grid;\r\n  gap: 1.25rem;\r\n  margin-top: 1.25rem;\r\n}\r\n\r\n.simulator-summary-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 1.25rem;\r\n  border-radius: var(--border-radius);\r\n}\r\n\r\n.simulator-summary-icon {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-summary-item div h4 {\r\n  font-weight: 700;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-summary-item div p {\r\n  opacity: 0.9;\r\n  font-size: 0.875rem;\r\n  margin: 0.25rem 0;\r\n}\r\n\r\n/* ===============================================\r\n   SERVICES INCLUS - ÉTAPE 4\r\n   =============================================== */\r\n.simulator-services-included {\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.simulator-services-header {\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-services-header .simulator-section-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-services-grid-enhanced {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 1.25rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-service-item-enhanced {\r\n  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.simulator-service-item-enhanced:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: var(--shadow-md);\r\n  border-color: var(--color-primary);\r\n}\r\n\r\n.simulator-service-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-service-icon-wrapper {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-service-icon {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  color: white;\r\n}\r\n\r\n.simulator-included-badge-new {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 15px;\r\n  font-weight: 700;\r\n  font-size: 0.7rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.simulator-check-icon-small {\r\n  width: 0.875rem;\r\n  height: 0.875rem;\r\n}\r\n\r\n.simulator-service-content h4 {\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-service-description {\r\n  color: var(--color-text-light);\r\n  line-height: 1.4;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-premium-guarantee {\r\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\r\n  border: 2px solid var(--color-warning);\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-guarantee-icon {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  background: var(--color-warning);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-guarantee-icon-svg {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  color: white;\r\n}\r\n\r\n.simulator-guarantee-content h4 {\r\n  font-weight: 700;\r\n  color: #92400e;\r\n  margin-bottom: 0.75rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-guarantee-features {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-guarantee-features span {\r\n  background: rgba(255, 255, 255, 0.8);\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: var(--border-radius);\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #92400e;\r\n}\r\n\r\n.simulator-rge-certification {\r\n  margin-top: 1rem;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid rgba(146, 64, 14, 0.2);\r\n}\r\n\r\n.simulator-rge-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  padding: 0.75rem 1rem;\r\n  border-radius: var(--border-radius);\r\n  text-decoration: none;\r\n  color: #92400e;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.simulator-rge-badge:hover {\r\n  background: white;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.simulator-rge-cert-logo {\r\n  width: 1.5rem;\r\n  height: auto;\r\n}\r\n\r\n/* ===============================================\r\n   IMPACT ENVIRONNEMENTAL\r\n   =============================================== */\r\n.simulator-environmental-impact {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.25rem;\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n  border: 1px solid var(--color-success);\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.simulator-environmental-icon {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  color: var(--color-success);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-environmental-impact h3 {\r\n  font-weight: 700;\r\n  color: #065f46;\r\n  margin-bottom: 0.75rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-environmental-impact p {\r\n  color: #065f46;\r\n  font-weight: 500;\r\n  line-height: 1.4;\r\n  margin: 0.375rem 0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-final-cta-container {\r\n  text-align: center;\r\n}\r\n\r\n.simulator-cta-subtitle {\r\n  margin-top: 0.75rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* ===============================================\r\n   RÉCAPITULATIF PRIX - ÉTAPE 4\r\n   =============================================== */\r\n.simulator-pricing-summary {\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 2rem;\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.simulator-summary-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-summary-star {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  color: var(--color-warning);\r\n}\r\n\r\n.simulator-summary-header h3 {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-bill-transformation {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.simulator-transformation-title {\r\n  font-size: 0.875rem;\r\n  opacity: 0.9;\r\n  margin-bottom: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-bill-before-after {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  gap: 0.75rem;\r\n  align-items: center;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.simulator-bill-old,\r\n.simulator-bill-new {\r\n  text-align: center;\r\n}\r\n\r\n.simulator-bill-old span,\r\n.simulator-bill-new span {\r\n  display: block;\r\n  font-size: 0.8rem;\r\n  opacity: 0.8;\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.simulator-amount-old {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  opacity: 0.7;\r\n  text-decoration: line-through;\r\n}\r\n\r\n.simulator-amount-new {\r\n  font-size: 1.75rem;\r\n  font-weight: 800;\r\n}\r\n\r\n.simulator-transformation-arrow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-arrow {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n}\r\n\r\n.simulator-monthly-savings {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  padding: 0.5rem;\r\n  border-radius: var(--border-radius);\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-bill-disclaimer-summary {\r\n  font-size: 0.7rem;\r\n  color: rgba(255, 255, 255, 0.6);\r\n  margin-top: 0.375rem;\r\n}\r\n\r\n.simulator-pricing-details {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.simulator-detail-section {\r\n  margin-bottom: 1.25rem;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.simulator-detail-section:last-child {\r\n  border-bottom: none;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.simulator-detail-section h4 {\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  margin-bottom: 0.75rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.simulator-detail-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.simulator-detail-item span:first-child {\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-detail-item span:last-child {\r\n  font-weight: 600;\r\n  color: var(--color-text);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-detail-item.simulator-prominent {\r\n  background: var(--color-surface);\r\n  padding: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-detail-item.simulator-prominent span:last-child {\r\n  color: var(--color-primary);\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.simulator-savings-amount {\r\n  color: var(--color-success) !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.simulator-guarantee-badges {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\r\n  gap: 0.75rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.simulator-badge-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.375rem;\r\n  background: var(--color-surface);\r\n  padding: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  text-align: center;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-badge-icon {\r\n  width: 1.125rem;\r\n  height: 1.125rem;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-badge-item span {\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  color: var(--color-text-light);\r\n}\r\n\r\n.simulator-contact-expert {\r\n  background: linear-gradient(135deg, var(--color-surface), #f1f5f9);\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  text-align: center;\r\n  margin-top: 1.25rem;\r\n  border: 2px solid #e2e8f0;\r\n}\r\n\r\n.simulator-expert-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-expert-icon {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-expert-header div {\r\n  text-align: left;\r\n}\r\n\r\n.simulator-expert-header p {\r\n  margin: 0;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-expert-subtitle {\r\n  font-size: 0.8rem;\r\n  color: var(--color-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.simulator-expert-contacts {\r\n  display: grid;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-expert-contact {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  background: white;\r\n  padding: 0.875rem;\r\n  border-radius: var(--border-radius);\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.simulator-phone-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: var(--color-primary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.simulator-contact-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: left;\r\n  flex: 1;\r\n}\r\n\r\n.simulator-contact-type {\r\n  font-size: 0.8rem;\r\n  color: var(--color-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-contact-details strong {\r\n  font-size: 0.875rem;\r\n  color: var(--color-text);\r\n  font-weight: 700;\r\n}\r\n\r\n.simulator-expert-hours {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  background: rgba(30, 64, 175, 0.1);\r\n  padding: 0.5rem;\r\n  border-radius: var(--border-radius);\r\n  font-size: 0.8rem;\r\n  color: var(--color-primary);\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-hours-icon {\r\n  width: 0.875rem;\r\n  height: 0.875rem;\r\n}\r\n\r\n/* ===============================================\r\n   STICKY FOOTER NAVIGATION\r\n   =============================================== */\r\n.simulator-sticky-footer {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: linear-gradient(135deg, var(--color-primary), #1d4ed8);\r\n  color: white;\r\n  box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);\r\n  z-index: var(--z-sticky);\r\n}\r\n\r\n.simulator-sticky-content {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 1rem 1.5rem;\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto;\r\n  gap: 2rem;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-sticky-nav-left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.simulator-nav-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.75rem 1.25rem;\r\n  border-radius: var(--border-radius);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  border: none;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-nav-btn.simulator-prev {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  color: white;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.simulator-nav-btn.simulator-prev:hover {\r\n  background: rgba(255, 255, 255, 0.25);\r\n  transform: translateX(-2px);\r\n}\r\n\r\n.simulator-sticky-savings {\r\n  text-align: center;\r\n  flex: 1;\r\n}\r\n\r\n.simulator-sticky-title {\r\n  font-weight: 600;\r\n  margin-bottom: 0.75rem;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-sticky-bills-comparison {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-sticky-bill-old,\r\n.simulator-sticky-bill-new {\r\n  text-align: center;\r\n}\r\n\r\n.simulator-sticky-bill-old span,\r\n.simulator-sticky-bill-new span {\r\n  display: block;\r\n  font-size: 0.75rem;\r\n  opacity: 0.8;\r\n  margin-bottom: 0.25rem;\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-sticky-amount-old {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  color: #fca5a5;\r\n  text-decoration: line-through;\r\n  opacity: 0.8;\r\n}\r\n\r\n.simulator-sticky-amount-new {\r\n  font-size: 1.375rem;\r\n  font-weight: 800;\r\n  color: #86efac;\r\n}\r\n\r\n.simulator-sticky-arrow {\r\n  font-size: 1rem;\r\n  color: #86efac;\r\n  font-weight: bold;\r\n  margin: 0 0.375rem;\r\n}\r\n\r\n.simulator-sticky-pricing {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.25rem;\r\n}\r\n\r\n.simulator-sticky-price {\r\n  text-align: right;\r\n}\r\n\r\n.simulator-sticky-label {\r\n  display: block;\r\n  font-size: 0.8rem;\r\n  opacity: 0.8;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.simulator-sticky-amount {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: white;\r\n}\r\n\r\n.simulator-sticky-cta {\r\n  background: linear-gradient(135deg, var(--color-success), #047857);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.875rem 1.5rem;\r\n  border-radius: var(--border-radius);\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.simulator-sticky-cta:hover:not(:disabled) {\r\n  background: linear-gradient(135deg, #047857, #065f46);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.simulator-sticky-cta:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ===============================================\r\n   MODALES\r\n   =============================================== */\r\n.simulator-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: var(--z-modal);\r\n  padding: 1.5rem;\r\n}\r\n\r\n.simulator-modal-content {\r\n  background: white;\r\n  border-radius: 10px;\r\n  max-width: 450px;\r\n  width: 100%;\r\n  max-height: 75vh;\r\n  overflow-y: auto;\r\n  box-shadow: var(--shadow-lg);\r\n  animation: simulator-fadeInUp 0.3s ease-out;\r\n}\r\n\r\n.simulator-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 1.25rem 1.25rem 1rem;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.simulator-modal-icon {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  background: linear-gradient(135deg, var(--color-primary), #2563eb);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n}\r\n\r\n.simulator-modal-header h3 {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  color: var(--color-text);\r\n  margin: 0;\r\n  flex: 1;\r\n}\r\n\r\n.simulator-modal-close {\r\n  background: none;\r\n  border: none;\r\n  color: var(--color-text-light);\r\n  cursor: pointer;\r\n  padding: 0.375rem;\r\n  border-radius: var(--border-radius);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.simulator-modal-close:hover {\r\n  background: #f1f5f9;\r\n  color: var(--color-text);\r\n}\r\n\r\n.simulator-modal-body {\r\n  padding: 1rem 1.25rem 1.25rem;\r\n}\r\n\r\n.simulator-modal-body p {\r\n  color: var(--color-text-light);\r\n  line-height: 1.5;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-modal-details {\r\n  background: var(--color-surface);\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-modal-details p {\r\n  margin: 0;\r\n  color: var(--color-text);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-modal-price,\r\n.simulator-modal-included {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  padding: 1rem;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n\r\n.simulator-modal-price {\r\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\r\n  border: 1px solid var(--color-primary);\r\n  color: var(--color-primary);\r\n}\r\n\r\n.simulator-modal-included {\r\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\r\n  border: 1px solid var(--color-success);\r\n  color: #065f46;\r\n}\r\n\r\n.simulator-price-icon,\r\n.simulator-check-icon {\r\n  width: 1.125rem;\r\n  height: 1.125rem;\r\n}\r\n\r\n/* ===============================================\r\n   FOOTER\r\n   =============================================== */\r\n.simulator-app-footer {\r\n  background: linear-gradient(135deg, #1f2937, #374151);\r\n  color: white;\r\n  margin-top: 0;\r\n}\r\n\r\n.simulator-footer-content {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2.5rem 1.5rem 1.25rem;\r\n}\r\n\r\n.simulator-footer-main {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr;\r\n  gap: 2.5rem;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 2rem;\r\n  border-bottom: 1px solid #4b5563;\r\n}\r\n\r\n.simulator-footer-company {\r\n  max-width: 350px;\r\n}\r\n\r\n.simulator-footer-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.simulator-footer-logo-image {\r\n  width: 2rem;\r\n  height: auto;\r\n}\r\n\r\n.simulator-footer-logo div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.simulator-footer-logo-text {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: white;\r\n  line-height: 1;\r\n}\r\n\r\n.simulator-footer-tagline {\r\n  font-size: 0.75rem;\r\n  color: #9ca3af;\r\n  font-weight: 500;\r\n}\r\n\r\n.simulator-footer-description {\r\n  color: #d1d5db;\r\n  line-height: 1.5;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.simulator-footer-contact h4,\r\n.simulator-footer-certifications h4 {\r\n  font-weight: 700;\r\n  color: white;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.125rem;\r\n}\r\n\r\n.simulator-footer-contact-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.simulator-footer-contact-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-footer-icon {\r\n  width: 1.125rem;\r\n  height: 1.125rem;\r\n  color: #60a5fa;\r\n  flex-shrink: 0;\r\n  margin-top: 0.125rem;\r\n}\r\n\r\n.simulator-footer-contact-item div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.simulator-contact-label {\r\n  font-size: 0.8rem;\r\n  color: #9ca3af;\r\n  font-weight: 500;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.simulator-contact-value {\r\n  color: #f3f4f6;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  line-height: 1.3;\r\n}\r\n\r\n.simulator-cert-badges {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.simulator-cert-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: var(--border-radius);\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.simulator-cert-link {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\n.simulator-cert-link:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  transform: translateX(2px);\r\n}\r\n\r\n.simulator-cert-rge-logo {\r\n  width: 1.125rem;\r\n  height: auto;\r\n}\r\n\r\n.simulator-cert-icon {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  color: #fbbf24;\r\n}\r\n\r\n.simulator-website-link {\r\n  color: #60a5fa;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.simulator-website-link:hover {\r\n  color: #93c5fd;\r\n  transform: translateX(2px);\r\n}\r\n\r\n.simulator-footer-bottom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 1.25rem;\r\n  border-top: 1px solid #4b5563;\r\n  font-size: 0.875rem;\r\n  color: #9ca3af;\r\n}\r\n\r\n.simulator-footer-links {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.simulator-footer-links a {\r\n  color: #9ca3af;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.simulator-footer-links a:hover {\r\n  color: #d1d5db;\r\n}\r\n\r\n.simulator-footer-links span {\r\n  cursor: pointer;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.simulator-footer-links span:hover:not(:nth-child(even)) {\r\n  color: #d1d5db;\r\n}\r\n\r\n/* ===============================================\r\n   LIENS TÉLÉPHONE ET EMAIL\r\n   =============================================== */\r\n.simulator-phone-link,\r\n.simulator-email-link {\r\n  color: inherit;\r\n  text-decoration: none;\r\n  transition: all 0.2s ease;\r\n  border-radius: 4px;\r\n  padding: 0.125rem;\r\n}\r\n\r\n.simulator-phone-link:hover,\r\n.simulator-email-link:hover {\r\n  color: var(--color-primary);\r\n  background: rgba(30, 64, 175, 0.1);\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ===============================================\r\n   CLASSES UTILITAIRES\r\n   =============================================== */\r\n.simulator-positive {\r\n  color: var(--color-success) !important;\r\n}\r\n\r\n.simulator-negative {\r\n  color: var(--color-danger) !important;\r\n}\r\n\r\n.simulator-neutral {\r\n  color: var(--color-text-light) !important;\r\n}\r\n\r\n.simulator-primary {\r\n  color: var(--color-primary) !important;\r\n}\r\n\r\n.simulator-warning {\r\n  color: var(--color-warning) !important;\r\n}\r\n\r\n/* ===============================================\r\n   CORRECTIONS SPÉCIFIQUES POUR Z-INDEX ET OVERFLOW\r\n   =============================================== */\r\n\r\n/* S'assurer que les parents n'ont pas d'overflow hidden qui masquerait les suggestions */\r\n.simulator-hero-section,\r\n.simulator-hero-content,\r\n.simulator-main-form-container,\r\n.simulator-address-section {\r\n  overflow: visible !important;\r\n}\r\n\r\n/* S'assurer que les suggestions sont toujours visibles */\r\n.simulator-address-suggestions {\r\n  /* Forcer le z-index maximum */\r\n  z-index: 999999 !important;\r\n  /* S'assurer que l'élément est dans son propre contexte d'empilement */\r\n  position: absolute !important;\r\n  /* Éviter tout problème de transform qui pourrait créer un nouveau contexte */\r\n  transform: none !important;\r\n  will-change: auto !important;\r\n}\r\n\r\n/* Contexte d'empilement pour le conteneur de recherche */\r\n.simulator-address-search-container {\r\n  /* Créer un contexte d'empilement */\r\n  z-index: 1000;\r\n  position: relative;\r\n  /* S'assurer qu'il peut déborder */\r\n  overflow: visible !important;\r\n}\r\n\r\n/* ===============================================\r\n   RESPONSIVE DESIGN\r\n   =============================================== */\r\n@media (max-width: 1024px) {\r\n  .simulator-content-layout,\r\n  .simulator-offer-content {\r\n    grid-template-columns: 1fr;\r\n    gap: 2rem;\r\n  }\r\n\r\n  .simulator-right-panel {\r\n    position: relative;\r\n    top: auto;\r\n    order: -1;\r\n  }\r\n\r\n  .simulator-savings-hero {\r\n    grid-template-columns: 1fr;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .simulator-header-contact {\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    align-items: flex-end;\r\n  }\r\n\r\n  .simulator-footer-main {\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 2rem;\r\n  }\r\n\r\n  .simulator-footer-company {\r\n    grid-column: 1 / -1;\r\n    max-width: none;\r\n  }\r\n\r\n  .simulator-services-grid-enhanced {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .simulator-progress-content {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .simulator-sticky-content {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .simulator-sticky-nav-left {\r\n    order: 2;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .simulator-sticky-savings {\r\n    order: 1;\r\n  }\r\n\r\n  .simulator-sticky-pricing {\r\n    order: 3;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .simulator-leasing-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .simulator-battery-types-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .simulator-desktop-only {\r\n    display: none !important;\r\n  }\r\n\r\n  .simulator-step-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .simulator-header-content {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n    padding: 0.75rem 1rem;\r\n  }\r\n\r\n  .simulator-logo {\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .simulator-logo-text {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .simulator-logo-tagline {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .simulator-header-contact {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    flex-direction: row;\r\n  }\r\n\r\n  .simulator-contact-info {\r\n    gap: 0.75rem;\r\n    flex-direction: row;\r\n  }\r\n\r\n  .simulator-contact-item {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .simulator-progress-bar {\r\n    padding: 0.75rem 0;\r\n  }\r\n\r\n  .simulator-progress-content {\r\n    padding: 0 1rem;\r\n    justify-content: center;\r\n  }\r\n\r\n  .simulator-progress-navigation {\r\n    flex: 1;\r\n  }\r\n\r\n  .simulator-progress-steps {\r\n    margin-bottom: 0.5rem;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .simulator-progress-step {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .simulator-progress-line {\r\n    width: 1.5rem;\r\n    margin: 0 0.375rem;\r\n  }\r\n\r\n  .simulator-progress-labels {\r\n    gap: 2rem;\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .simulator-step-1 {\r\n    min-height: 75vh;\r\n    padding: 0;\r\n  }\r\n\r\n  .simulator-hero-section {\r\n    min-height: 75vh;\r\n    padding: 1.25rem 0;\r\n  }\r\n\r\n  .simulator-hero-content {\r\n    padding: 1.5rem 1.25rem;\r\n    margin: 0 1rem;\r\n    border-radius: 12px;\r\n  }\r\n\r\n  .simulator-hero-title {\r\n    font-size: 1.625rem;\r\n    line-height: 1.2;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .simulator-hero-subtitle {\r\n    font-size: 0.9rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .simulator-subtitle-features {\r\n    flex-direction: column;\r\n    gap: 0.375rem;\r\n    align-items: center;\r\n  }\r\n\r\n  .simulator-feature-pill {\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .simulator-main-form-container {\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .simulator-address-input-wrapper {\r\n    padding: 0 1rem;\r\n  }\r\n\r\n  .simulator-address-input {\r\n    padding: 1rem 0;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .simulator-main-cta-button {\r\n    padding: 1rem 1.25rem;\r\n    font-size: 0.9rem;\r\n    gap: 0.375rem;\r\n    min-width: 200px;\r\n  }\r\n\r\n  .simulator-address-suggestions {\r\n    border-radius: 8px;\r\n    margin-top: 0.375rem;\r\n    max-height: 240px;\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-suggestion-item {\r\n    padding: 0.75rem 1rem;\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-suggestion-label {\r\n    font-size: 0.875rem;\r\n    line-height: 1.2;\r\n  }\r\n\r\n  .simulator-suggestion-context {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .simulator-success-message {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    gap: 0.5rem;\r\n    padding: 1rem;\r\n    margin-top: 1.25rem;\r\n  }\r\n\r\n  .simulator-trust-indicators {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n    margin-top: 1.25rem;\r\n    padding-top: 1.25rem;\r\n  }\r\n\r\n  .simulator-price-card {\r\n    position: static;\r\n    margin-bottom: 1.5rem;\r\n    padding: 1.5rem;\r\n    border-radius: 12px;\r\n  }\r\n\r\n  .simulator-new-bill-highlight {\r\n    padding: 1.25rem;\r\n    margin-bottom: 1.25rem;\r\n  }\r\n\r\n  .simulator-new-bill-amount {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .simulator-pricing-summary {\r\n    padding: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .simulator-bill-transformation {\r\n    padding: 1.25rem;\r\n    margin-bottom: 1.25rem;\r\n  }\r\n\r\n  .simulator-amount-new {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .simulator-form-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .simulator-form-input {\r\n    padding: 1rem;\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-leasing-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .simulator-battery-types-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .simulator-battery-type-card {\r\n    min-height: auto;\r\n  }\r\n\r\n  .simulator-sticky-footer {\r\n    background: linear-gradient(135deg, var(--color-primary), #1d4ed8);\r\n  }\r\n\r\n  .simulator-sticky-content {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n    text-align: center;\r\n    padding: 1rem;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .simulator-sticky-nav-left {\r\n    position: absolute;\r\n    top: 0.5rem;\r\n    left: 0.75rem;\r\n    order: unset;\r\n  }\r\n\r\n  .simulator-nav-btn.simulator-prev {\r\n    background: rgba(255, 255, 255, 0.15);\r\n    color: white;\r\n    padding: 0.5rem 0.75rem;\r\n    font-size: 0.8rem;\r\n    border-radius: 6px;\r\n    backdrop-filter: blur(10px);\r\n  }\r\n\r\n  .simulator-nav-btn.simulator-prev:hover {\r\n    background: rgba(255, 255, 255, 0.25);\r\n  }\r\n\r\n  .simulator-sticky-savings {\r\n    order: 1;\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .simulator-sticky-title {\r\n    font-size: 0.875rem;\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  .simulator-sticky-bills-comparison {\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .simulator-sticky-amount-old {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .simulator-sticky-amount-new {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .simulator-sticky-arrow {\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-sticky-pricing {\r\n    order: 2;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 1rem;\r\n    margin-top: 0.75rem;\r\n  }\r\n\r\n  .simulator-sticky-price {\r\n    text-align: left;\r\n    flex: 1;\r\n  }\r\n\r\n  .simulator-sticky-label {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .simulator-sticky-amount {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n  .simulator-sticky-cta {\r\n    background: linear-gradient(135deg, var(--color-success), #047857);\r\n    padding: 0.75rem 1.25rem;\r\n    font-size: 0.875rem;\r\n    border-radius: 8px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .simulator-sticky-cta:hover:not(:disabled) {\r\n    background: linear-gradient(135deg, #047857, #065f46);\r\n  }\r\n\r\n  .simulator-panel-types-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .simulator-panel-type-card {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .simulator-panel-count-options {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .simulator-panel-count-option {\r\n    padding: 0.875rem 0.5rem;\r\n    margin-top: 0.75rem;\r\n  }\r\n\r\n  .simulator-leasing-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .simulator-leasing-card {\r\n    padding: 1.25rem;\r\n    margin-top: 0.75rem;\r\n  }\r\n\r\n  .simulator-bill-before-after {\r\n    grid-template-columns: 1fr auto 1fr;\r\n    gap: 0.75rem;\r\n    align-items: center;\r\n  }\r\n\r\n  .simulator-transformation-arrow {\r\n    order: 2;\r\n  }\r\n\r\n  .simulator-savings-preview-big {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 1rem;\r\n  }\r\n\r\n  .simulator-preview-item {\r\n    padding: 1rem 0.75rem;\r\n  }\r\n\r\n  .simulator-environmental-impact {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    gap: 1rem;\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .simulator-footer-content {\r\n    padding: 2rem 1rem 1rem;\r\n  }\r\n\r\n  .simulator-footer-main {\r\n    grid-template-columns: 1fr;\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .simulator-footer-company {\r\n    grid-column: auto;\r\n  }\r\n\r\n  .simulator-footer-bottom {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .simulator-footer-links {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n\r\n  .simulator-bill-section {\r\n    padding: 1.25rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .simulator-hero-content {\r\n    padding: 1.25rem 1rem;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .simulator-hero-title {\r\n    font-size: 1.5rem;\r\n    line-height: 1.1;\r\n    margin-bottom: 0.75rem;\r\n  }\r\n\r\n  .simulator-hero-subtitle {\r\n    font-size: 0.875rem;\r\n    margin-bottom: 1.25rem;\r\n  }\r\n\r\n  .simulator-address-input-wrapper {\r\n    padding: 0 0.875rem;\r\n  }\r\n\r\n  .simulator-address-input {\r\n    padding: 0.875rem 0;\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-main-cta-button {\r\n    padding: 0.875rem 1rem;\r\n    font-size: 0.875rem;\r\n    min-width: 180px;\r\n  }\r\n\r\n  .simulator-sticky-amount-new {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n  .simulator-sticky-cta {\r\n    padding: 0.75rem 1rem;\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .simulator-new-bill-mega {\r\n    font-size: 2.25rem;\r\n  }\r\n\r\n  .simulator-modal-overlay {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .simulator-panel-count-options {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .simulator-guarantee-badges {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  .simulator-footer-content {\r\n    padding: 1.5rem 0.875rem 0.875rem;\r\n  }\r\n\r\n  .simulator-footer-logo-text {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n  .simulator-footer-description {\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-footer-contact h4,\r\n  .simulator-footer-certifications h4 {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .simulator-contact-value {\r\n    font-size: 0.875rem;\r\n  }\r\n\r\n  .simulator-cert-badge {\r\n    padding: 0.375rem 0.5rem;\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .simulator-footer-bottom {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .simulator-bill-input {\r\n    font-size: 1.5rem;\r\n    width: 6rem;\r\n  }\r\n\r\n  .simulator-bill-currency {\r\n    font-size: 1.25rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
